/*globals playerjs:true*/
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import { isMobile } from 'react-device-detect';

import { LazyLoadImage } from 'root/webapp/components/ss2/atoms/image';
import provider from 'root/util/provider';
import core from 'root/util/core';
import memberService from 'root/util/member-service';
import { portalAction, dateAction, consolidateAPIAction, seamlessAction } from 'root/redux/action';
import {
    downloadBannerDesc,
    casinoTopBannerDesc,
    casinoBottomBannerDesc,
    slotTopBannerDesc,
    pokerTopBannerDesc,
    pokerBottomBannerDesc,
    lotteryTopBannerDesc,
    fishingTopBannerDesc,
    fishingBottomBannerDesc,
    sportTopBannerDesc,
    esportTopBannerDesc,
    esportBottomBannerDesc,
    games3DTopBannerDesc,
} from 'root/webapp/portal/home/data';
import { announcement_generateDelaySpeed } from 'root/util/announcement-util';
import SVGRenderer from 'root/components/Icon/SVGRenderer';
import providerCore from 'root/util/provider';
import { mu_getUserSeamlessStatus, mu_getSeamlessMemberWallet } from 'root/util//member-util';

import IMAGE from './image';
import { walletAction } from '../redux/action/wallet.action';
import { userAction } from '../redux/action/user.action';
import { PAYMENT_GATEWAY_SETTING } from './constants';
import {
    gu_jsonConcat,
    gu_proceedNestedObjectWithVM,
    gu_getContentByCurrencyLanguage,
    gu_getByViewType,
    gu_togglePopup,
    gu_getSettingFromPortalSettings,
    gu_getFeaturesFromPortalSettings,
    gu_updateComponentProps,
    gu_commonHrefRedirect,
    gu_loadCustomTranslation,
    gu_getAffiliateLink,
    gu_getNestedValue,
    gu_popupUpdate,
    gu_triggerAdElementAction,
    gu_getSubmenuMenu,
    gu_postExternalCampainPostback,
    gu_filterCommonKey,
    gu_dropdownUpdate,
    gu_updateUserSeamless,
    gu_getContactList,
    gu_inWords,
    gu_changeLanguageArrangementSort,
    gu_orderArray,
    gu_getDepositImgPath,
    gu_formatCurrentLanguage,
    gu_checkIsArrayAndHasLength,
    gu_triggerExternalMerchantAction,
    gu_initComm100,
} from './general-util';

// cache playerjs instances per iframe to avoid repeated construction
const EMBED_PLAYER_MAP = new WeakMap();

export function getOrCreateEmbedPlayer(iframe) {
    if (!iframe) return null;
    let player = EMBED_PLAYER_MAP.get(iframe);
    if (!player) {
        player = new playerjs.Player(iframe);
        EMBED_PLAYER_MAP.set(iframe, player);
    }
    return player;
}

const commonUtil = {
    // contactDisplayType
    // 1: all contact
    // 2: exclude social media (default)
    // 3: only social media
    // 4: customer service list (refer eb88 mobile contact us)
    getContactList(vm, language, type, contactDisplayType = 2) {
        return vm.props.dispatch(portalAction.getContactList(vm, language, type, contactDisplayType));
        // return gu_getContactList(language, type, contactDisplayType);
    },

    // timezoneLayout
    // longGmtTimezone = GMT+0800 (Malaysia Time)
    // shortGmtTimezone = GMT+8
    getNavbarLiveDateTimeFormat(props) {
        const { portalSettings } = props?.portalSettingsReducer || {};
        // default format
        let datetimeFormat = 'D/M/YYYY h:mm:ssa';
        let timezoneLayout = 'shortGmtTimezone';

        if (portalSettings && portalSettings.features && portalSettings.features.navbarDateTimeDisplay) {
            if (portalSettings.features.navbarDateTimeDisplay.datetimeFormat) {
                datetimeFormat = portalSettings.features.navbarDateTimeDisplay.datetimeFormat;
            }
            if (portalSettings.features.navbarDateTimeDisplay.timezoneLayout) {
                timezoneLayout = portalSettings.features.navbarDateTimeDisplay.timezoneLayout;
            }
        }

        return {
            datetimeFormat: datetimeFormat,
            timezoneLayout: timezoneLayout,
        };
    },

    massageAnnouncementStyleAndProceedAnimation(vm, isMoveVertical) {
        const { portalSettings } = vm.props?.portalSettingsReducer || {};
        if (!gu_getNestedValue(portalSettings, 'features.announcementConfig.disableAnnounceAnimation')) {
            let contentDiv = document.getElementById('msg-content');
            let textDiv = document.getElementById('msgAnimate');
            let textSpeed = 60;
            let linearTime = 0;
            let contentWidth = 0;
            let textWidth = 0;
            let specialTranslate = null;
            let customKeyframe = null;
            let customTextColor = null;
            let speedConstant = 1710.4;
            let rateOfSpeed = textSpeed / speedConstant;

            if (textDiv && contentDiv) {
                if (isMoveVertical) {
                    customKeyframe = 'custom-noticeFade';
                    let style = document.createElement('style');
                    // style.innerText = keyframes;
                    document.head.appendChild(style);
                    setTimeout(() => {
                        vm.setState({
                            in: true,
                            customTextColor: null,
                            customKeyframe: customKeyframe,
                        });
                    }, 0);
                } else {
                    contentWidth = contentDiv.offsetWidth;
                    textWidth = textDiv.offsetWidth;

                    if (textWidth < contentWidth) {
                        let diffpx = contentWidth - textWidth;
                        let diffpercentage = (diffpx / textWidth) * 100;
                        diffpercentage += 100 + 5; // add 5 more percentage so not too fast come out
                        specialTranslate = 'translateX(' + diffpercentage + '%) translateZ(0)';

                        customKeyframe = 'custom-noticeFade';
                        let keyframes = `@keyframes ${customKeyframe} { 0% { transform: translateX(${diffpercentage}%); } 100% { transform: translateX(-100%); } }`;

                        let style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerText = keyframes;
                        document.head.appendChild(style);

                        textWidth = contentWidth;
                    } else {
                        // NOTE: bigger already no need +100%, textWidth = 100%, contentWidth = ?
                        // add 5 more percentage so not too fast come out
                        let diffpercentage = (contentWidth * 100) / textWidth + 5;
                        specialTranslate = 'translateX(' + diffpercentage + '%) translateZ(0)';

                        customKeyframe = 'custom-noticeFade';
                        let keyframes = `@keyframes ${customKeyframe} { 0% { transform: translateX(${diffpercentage}%); } 100% { transform: translateX(-100%); } }`;

                        let style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerText = keyframes;
                        document.head.appendChild(style);

                        let multiplier = textWidth / contentWidth;
                        if (multiplier >= 4) {
                            rateOfSpeed = 35 / speedConstant;
                        } else if (multiplier >= 3) {
                            rateOfSpeed = 45 / speedConstant;
                        }
                    }

                    linearTime = textWidth * rateOfSpeed;

                    // try to get announcement color
                    let viewType = vm.props.screen.viewType;

                    if (portalSettings && portalSettings.features && portalSettings.features.getAnnoucementStyle) {
                        window.SPL_Content.getAnnoucementStyle().then((announcementStyle) => {
                            if (announcementStyle) {
                                if (viewType === 'web' && announcementStyle.color) {
                                    customTextColor = announcementStyle.color;
                                } else if (viewType === 'mobile' && announcementStyle.mColor) {
                                    customTextColor = announcementStyle.mColor;
                                }
                            }
                            setTimeout(() => {
                                vm.setState({
                                    announcementSpeed: linearTime.toFixed(2),
                                    announcementDelaySpeed: announcement_generateDelaySpeed(linearTime, vm),
                                    specialTranslate: specialTranslate,
                                    customKeyframe: customKeyframe,
                                    in: true,
                                    customTextColor: customTextColor,
                                    announcementColor: customTextColor,
                                });
                            }, 0);
                        });
                    } else {
                        setTimeout(() => {
                            vm.setState({
                                announcementSpeed: linearTime,
                                announcementDelaySpeed: announcement_generateDelaySpeed(linearTime, vm),
                                specialTranslate: specialTranslate,
                                customKeyframe: customKeyframe,
                                in: true,
                                customTextColor: null,
                            });
                        }, 0);
                    }
                }
            }
        }
    },

    // Get Custom Translation from /public/html/settings/custom-translation.json
    // (Parameter) currentPage: refer as the page requesting and the key of the custom-translation.json
    loadCustomTranslation(currentPage, vm, callback) {
        if (callback) {
            callback(gu_loadCustomTranslation(currentPage, vm, callback));
        }
        return gu_loadCustomTranslation(currentPage, vm, callback);
    },

    lauchGameFromIndex(providerObj, isFun, vm) {
        providerObj.isFun = isFun;
        const { language, user, screen } = vm.props;

        provider.launchGameFromMenu(providerObj, language, user.isLogin, screen, vm.props);
    },

    checkIsArrayAndHasLength(array) {
        return gu_checkIsArrayAndHasLength(array);
    },

    checkResigterWithContactSupport(vm, viewType) {
        let regContactSupport = {};
        const { features } = vm.props?.portalSettingsReducer?.portalSettings || {};
        return new Promise(function (resolve) {
            let countryLanguageKey = '';
            if (vm.props.language && vm.props.language.countryLanguageKey) {
                countryLanguageKey = vm.props.language.countryLanguageKey.toLowerCase().replace('_', '-');
            } else if (vm.props.countryLanguageKey) {
                countryLanguageKey = vm.props.countryLanguageKey.toLowerCase().replace('_', '-');
            } else {
                resolve();
            }

            if (features?.resigterWithContactSupport) {
                regContactSupport = features?.resigterWithContactSupport;
            } else {
                resolve();
            }

            let regWithContactSupport = {
                isEnabled: false,
            };

            if (regContactSupport && regContactSupport.length > 0) {
                for (var i = 0; i < regContactSupport.length; i++) {
                    if (regContactSupport[i].domain.length > 0) {
                        if (regContactSupport[i].domain.includes(window.location.hostname)) {
                            if (regContactSupport[i][viewType + 'Link']) {
                                regWithContactSupport = {
                                    isEnabled: true,
                                    type: regContactSupport[i].type,
                                    name: regContactSupport[i].name[countryLanguageKey] ? regContactSupport[i].name[countryLanguageKey] : 'Contact Support',
                                    link: regContactSupport[i][viewType + 'Link'],
                                };
                            }
                        }
                    }
                }
            }

            vm.setState({ regWithContactSupport }, () => {
                resolve();
            });
        });
    },

    downloadAPK(os, vm) {
        const { appDownloadData, iosDownloadLink, androidDownloadLink } = vm.state;
        // Specific for Safari on iOS, open a blank window immediately
        let windowReference = window;
        if (os === 'ios' && appDownloadData.isIOSRedirect) {
            windowReference = window.open('', '_blank');
        }
        window.SPL_LiteApp.getLiteAppAffiliate().then((affiliateId) => {
            if (affiliateId) {
                window.SPL_LiteApp.setLiteAppAffiliate(affiliateId);
            }

            if (os === 'ios') {
                const iOSLink = iosDownloadLink || appDownloadData?.iosDownloadLink || '';
                if (appDownloadData.isIOSRedirect) {
                    if (windowReference && windowReference.location) {
                        windowReference.location.href = iOSLink;
                    }
                } else {
                    commonUtil.downloadCustomIosApp(vm);
                }
            } else if (os === 'android') {
                if (appDownloadData.isAndroidRedirect) {
                    window.open(androidDownloadLink || appDownloadData?.androidDownloadLink, '');
                } else {
                    commonUtil.downloadCustomAndroidApp(vm);
                }
            }
        });
    },

    downloadCustomIosApp(vm, type) {
        const { portalSettingsReducer } = vm.props;

        // custom link = hardcode link, will direct get the link from the custom settings and navigate
        let customIosLink = gu_getNestedValue(portalSettingsReducer.portalSettings, 'features.customMobileHomeAppBannerDownloadLink.ios') || false;

        if (customIosLink) {
            window.location.href = customIosLink;
        } else {
            if (type === 'camouflageapp') {
                commonUtil.getCamoIosLink(vm);
            } else {
                commonUtil.getLiteAppIosLink(vm);
            }
        }
    },

    getLiteAppIosLink(vm) {
        const { appDownloadData } = vm.state;
        const { language } = vm.props;

        if (appDownloadData && appDownloadData.dynamicApkLink && appDownloadData.iosDownloadLink) {
            window.location.href = appDownloadData.iosDownloadLink;
        } else {
            window.SPL_JsonSettings.getAppDownloadLinkJson((data) => {
                let affCode = window.SPL_Cookie.getCookie('AffCode');
                if (data && data.ios) {
                    let url = null;

                    if (data.iosLanguage && data.iosLanguage[language.key]) {
                        url = data.iosLanguage[language.key];
                    } else {
                        url = gu_getContentByCurrencyLanguage(vm, data.ios);
                    }
                    url = core.replaceAll(url, '<affiliate ID>', affCode);
                    window.location.href = url;
                } else {
                    commonUtil.getCamoIosLink(vm);
                }
            });
        }
    },

    getCamoIosLink(vm) {
        const { appDownloadData, camouflageAppDownloadData } = vm.state;
        const { language, history } = vm.props;

        if (camouflageAppDownloadData && camouflageAppDownloadData.dynamicApkLink && camouflageAppDownloadData.iosDownloadLink) {
            window.location.href = camouflageAppDownloadData.iosDownloadLink;
        } else {
            window.SPL_JsonSettings.getAppDownloadLinkJson((data) => {
                let camoData = data.camouflageapp;
                let affCode = window.SPL_Cookie.getCookie('AffCode');
                if (camoData && camoData.ios) {
                    let url = null;

                    if (camoData.iosLanguage && camoData.iosLanguage[language.key]) {
                        url = camoData.iosLanguage[language.key];
                    } else {
                        url = gu_getContentByCurrencyLanguage(vm, camoData.ios);
                    }
                    url = core.replaceAll(url, '<affiliate ID>', affCode);
                    window.location.href = url;
                } else {
                    let tabList = appDownloadData.tabList;
                    let filterTabList = [];
                    if (tabList && tabList.length > 0) {
                        filterTabList = tabList.filter(function (el) {
                            return el.tabName === 'iosapp' || el.tabName === 'androidapp';
                        });
                    }

                    if (filterTabList.length > 0) {
                        history.push('/download');
                    }
                }
            });
        }
    },

    downloadCustomAndroidApp(vm, type) {
        const { portalSettingsReducer } = vm.props;

        let downloadLink = null;
        let apkName = 'app.apk';

        // custom link = hardcode link, will direct get the link from the custom settings and download
        let customApkLink = gu_getNestedValue(portalSettingsReducer.portalSettings, 'features.customMobileHomeAppBannerDownloadLink.android') || false;

        if (customApkLink) {
            downloadLink = customApkLink;
        } else {
            if (type === 'camouflageapp') {
                if (vm.state.camouflageAppDownloadData && vm.state.camouflageAppDownloadData.apkDownloadLink) {
                    downloadLink = gu_getContentByCurrencyLanguage(vm, vm.state.camouflageAppDownloadData.apkDownloadLink);
                    if (vm.state.camouflageAppDownloadData.apkName) {
                        apkName = vm.state.camouflageAppDownloadData.apkName;
                    }
                }
            } else {
                if (vm.state.appDownloadData && vm.state.appDownloadData.apkDownloadLink && vm.state.appDownloadData.apkDownloadLink !== '') {
                    downloadLink = gu_getContentByCurrencyLanguage(vm, vm.state.appDownloadData.apkDownloadLink);
                    if (vm.state.appDownloadData.apkName) {
                        apkName = vm.state.appDownloadData.apkName;
                    }
                } else if (
                    vm.state.camouflageAppDownloadData &&
                    vm.state.camouflageAppDownloadData.apkDownloadLink &&
                    vm.state.camouflageAppDownloadData.apkDownloadLink !== ''
                ) {
                    downloadLink = gu_getContentByCurrencyLanguage(vm, vm.state.camouflageAppDownloadData.apkDownloadLink);
                    if (vm.state.camouflageAppDownloadData.apkName) {
                        apkName = vm.state.camouflageAppDownloadData.apkName;
                    }
                } else {
                    let tabList = vm.state.appDownloadData.tabList;
                    let filterTabList = tabList.filter(function (el) {
                        return el.tabName === 'iosapp' || el.tabName === 'androidapp';
                    });
                    if (filterTabList.length > 0) {
                        vm.props.history.push('/download');
                    }
                }
            }
        }

        if (downloadLink) {
            if (downloadLink.includes('androidCamouflage')) {
                window.location.href = downloadLink;
            } else {
                core.downloadUrl(downloadLink, apkName);
            }
        }
    },

    isValidUrl(link) {
        return /^https?:\/\//.test(link);
    },

    getSubmenuMenu(vm, menu) {
        return gu_getSubmenuMenu(vm, menu);
    },

    redirectToAffiliatePage(affUrl) {
        if (affUrl && affUrl !== '') {
            window.location.href = affUrl;
        }
    },

    getAffiliateLink(vm, withTimeout = true) {
        gu_getAffiliateLink(vm, withTimeout);
    },

    setLivechatUrl(vm) {
        commonUtil.getContactList(vm, vm.props.language.countryLanguageKey, vm.props.screen.viewType, 1).then((data) => {
            for (let i = 0; i < data.length; i++) {
                if (data[i].name === 'LiveChat') {
                    vm.setState({ liveChatUrl: data[i].url });
                    break;
                }
            }
        });
    },

    triggerExternalMerchantAction(action, extraParam) {
        return gu_triggerExternalMerchantAction(action, extraParam);
    },

    retryUntil(predicate, callback, {
        interval = 1000,
        timeout = 5000,
    } = {}) {
        const start = Date.now();
        (function poll() {
            if (predicate()) {
                callback();
                return;
            }

            if (Date.now() - start >= timeout) return;

            setTimeout(poll, interval);
        })();
    },

    initPixelPostbackEvent(platformData = {}) {
        Object.keys(platformData).forEach((platfromName) => {
            switch (platfromName) {
                case 'FB':
                    platformData[platfromName]?.platformSettings?.forEach((platformSetting, index) => {
                        if (!index) window.SPL_Handler?.injectFBPixelByParamId?.({ fbid: platformSetting.platformTrackingId });
                        else window.fbq?.('init', platformSetting.platformTrackingId);
                    });
                    break;
                case 'TT':
                    platformData[platfromName]?.platformSettings?.forEach(({ platformTrackingId: tiktokId }) => {
                        if (!tiktokId) return;
                        if (!window.ttq) {
                            window.SPL_Handler?.injectTiktokByParamId?.({
                                ttDynamicPixel: tiktokId,
                                tiktokId,
                            });
                            return;
                        }
                        commonUtil.retryUntil(
                            () => typeof window.ttq?.loadPixel === 'function',
                            () => window.ttq.loadPixel(tiktokId)
                        );
                    });
                    window.ttq?.enableCookie?.();
                    break;
                case 'GA4':
                    platformData[platfromName]?.platformSettings?.forEach((platformSetting, index) => {
                        if (!index) window.SPL_Handler?.injectGtagByParamId?.({ gtagId: platformSetting.platformTrackingId });
                        else window.gtag?.('config', platformSetting.platformTrackingId);
                    });
                    break;
                case 'SPR':
                    platformData[platfromName]?.platformSettings?.forEach((platformSetting, index) => {
                        if (!index) window.SPL_Handler?.injectSportRadarByParamId?.({ sportRadarId: platformSetting.platformTrackingId });
                    });
                    break;
                default:
                    return;
            }
        });
    },

    // Callers prepare event-specific fields. Resolves false when skipped or failed.
    trackAppsFlyerEvent(event, params = {}) {
        if (typeof window === 'undefined') return false;

        try {
            if (typeof event !== 'string' || !event.trim() || !params || typeof params !== 'object' || Array.isArray(params)) return false;

            const bridge = window?.jsBridge;
            if (typeof bridge?.track !== 'function') return false;

            bridge.track(event, params);
            // This confirms the bridge call completed, not delivery to AppsFlyer.
            return true;
        } catch (error) {
            console.warn('[AppsFlyer] Bridge call failed:', event, error);
            return false;
        }
    },

    triggerPixelPostbackEvent(platformData = {}, action) {
        Object.keys(platformData).forEach((platfromName) => {
            if (!Object.keys(platformData[platfromName].eventPostbackSettings?.[action] || {}).length) return;
            switch (platfromName) {
                case 'FB': {
                    const eventName = platformData[platfromName].eventPostbackSettings?.[action]?.event_name || action;
                    window.fbq?.('trackCustom', eventName, platformData[platfromName].eventPostbackSettings?.[action] || {});
                    break;
                }
                case 'TT': {
                    platformData[platfromName]?.platformSettings?.forEach((platformSetting) => {
                        const tiktokId = platformSetting?.platformTrackingId;
                        const eventName = platformData[platfromName].eventPostbackSettings?.[action]?.event || action;
                        if (tiktokId) {
                            window.ttq?.instance?.(tiktokId)?.track?.(eventName, platformData[platfromName].eventPostbackSettings?.[action] || {});
                        }
                    });
                    break;
                }
                case 'GA4': {
                    const eventName = platformData[platfromName].eventPostbackSettings?.[action]?.name || action;
                    window.gtag?.('event', eventName, platformData[platfromName].eventPostbackSettings?.[action] || {});
                    break;
                }
                case 'SPR': {
                    const eventName = platformData[platfromName].eventPostbackSettings?.[action]?.eventname || action;
                    const payload = omit(platformData?.[platfromName]?.eventPostbackSettings?.[action] ?? {}, ['eventname']);
                    window.srtmCommands?.push({
                        event: eventName,
                        payload,
                    });
                    break;
                }
                default:
                    return;
            }
        });
    },

    async revokePlatformEventTrigger() {
        window.SPL_Cookie.deleteCookie('EVENT_POSTBACK_PARAMS');
        window.SPL_Cookie.deleteCookie('EVENT_POSTBACK_PARAMS_ACTION');
        setTimeout(() => {
            window.fbq?.('consent', 'revoke');
            window.ttq?.disableCookie();
            window.gtag?.('consent', 'update', {
                ad_storage: 'denied',
                analytics_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
            });
        }, 10000);
    },

    getCountryInfo(vm) {
        return new Promise(function (resolve) {
            window.SPL_JsonSettings.getTelCodeSettings(function (telcodeSettings) {
                vm.setState({ telcodeSettings: telcodeSettings });
                window.SPL_Content.getCountryInfo().then((telCodeList) => {
                    vm.setState({ telCodeList: telCodeList }, () => {
                        resolve();
                    });
                });
            });
        });
    },

    injectAgentMobileStyle(vm) {
        let id = 'custom-agent-mobile-font-style';
        if (vm.props.screen.viewType === 'web') {
            let foundExist = document.getElementById(id);
            if (foundExist) {
                document.removeChild(foundExist);
            }
        } else {
            //inject style
            let style = document.createElement('style');
            style.id = id;
            style.type = 'text/css';
            style.innerText = 'html { font-size: calc(100vw / 12); } body {font-size: 0.16rem;}';
            document.head.appendChild(style);
        }
    },

    // find if using template set images and generate <img /> tag
    // params = {portalSettings, submenu}
    // props => this.props;
    // portalSettings => this.props.portal.settings (required)
    // template => The type of template folder name (required)
    // className => className for the <img /> tag
    // images => the new images name inside the template folder
    // hoverImages => images show when on hvoer
    // style => images tag styling
    // fallbackImages => old images load back when new images not found (required)
    renderTemplateImgTag(params, vm) {
        if (!params) {
            // NOTE: a way to detect environment? if PROD don't show console.
            console.warn('commonUtil :: renderTemplateImgTag : Please Insert Params.');
            return;
        }

        let imageSrc = params.images;
        let fallbackSrc = vm ? commonUtil.getContentByCurrencyLanguage(vm, params.fallbackImages) : params.fallbackImages;
        let settingTemplate = params.template.replace(/-/g, '_'); // Portal Settings is same name as the template folder name & replace - with _
        let hoverImagesSrc = params.hoverImages;
        let fileName = params.className ? params.className.replace(/-/g, '_') : null;
        let enlargeMenuCount = params.enlargeMenuCount;

        let selectedTemplateSet = null;
        let selectedTemplateSetFormat = 'png'; // default image format
        let indexImagesTemplate = window?.imagesTemplate?.[settingTemplate]?.[params.props.screen.viewType];

        let imgSplit = imageSrc ? (imageSrc.constructor === Array ? imageSrc[0].split('.') : imageSrc.split('.')) : '';
        let fallbackImgSplit = fallbackSrc ? (fallbackSrc.constructor === Array ? fallbackSrc[0].split('.') : fallbackSrc.split('.')) : '';
        if (enlargeMenuCount) {
            if (imgSplit && imgSplit.length > 0) {
                imageSrc = imgSplit[0] + '-L.' + imgSplit[1];
            }

            if (fallbackImgSplit && fallbackImgSplit.length > 0) {
                fallbackSrc = fallbackImgSplit[0] + '-L.' + fallbackImgSplit[1];
            }
        }

        if (
            params.template !== 'footer-icon' &&
            params.portalSettings &&
            params.portalSettings.images_template &&
            (settingTemplate === 'submenu_icon' ? indexImagesTemplate : params.portalSettings.images_template[settingTemplate])
        ) {
            let imagesTemplate =
                settingTemplate === 'submenu_icon'
                    ? indexImagesTemplate
                    : params?.customImagesTemplate?.[settingTemplate] || params.portalSettings.images_template[settingTemplate];
            if (params.props && params.props.screen && params.props.screen.isMobile) {
                let mobileSettingTemplate = 'm_' + settingTemplate;
                if (params.portalSettings.images_template[mobileSettingTemplate]) {
                    selectedTemplateSet = params.portalSettings.images_template[mobileSettingTemplate];
                } else {
                    if (settingTemplate === 'submenu_icon') {
                        selectedTemplateSet = indexImagesTemplate;
                    } else {
                        selectedTemplateSet = params?.customImagesTemplate?.[settingTemplate] || params.portalSettings.images_template[settingTemplate];
                    }
                }
            } else if (imagesTemplate[fileName]) {
                selectedTemplateSet = imagesTemplate[fileName];
            } else {
                if (indexImagesTemplate && settingTemplate === 'submenu_icon') {
                    selectedTemplateSet = indexImagesTemplate;
                } else {
                    selectedTemplateSet = params?.customImagesTemplate?.[settingTemplate] || params.portalSettings.images_template[settingTemplate];
                }
            }
        } else if (params.imagesTemplateSettings && params.imagesTemplateSettings.footerImageTemplate) {
            selectedTemplateSet = params.imagesTemplateSettings.footerImageTemplate;
        }

        if (selectedTemplateSet) {
            selectedTemplateSet = gu_filterCommonKey(selectedTemplateSet);
        }

        if (params.imagesTemplateSettings && params.imagesTemplateSettings.footerImageTemplate) {
            selectedTemplateSet = params.imagesTemplateSettings.footerImageTemplate;
        }

        if (
            selectedTemplateSet &&
            IMAGE.TEMPLATE_IMAGE_FORMAT &&
            IMAGE.TEMPLATE_IMAGE_FORMAT[settingTemplate] &&
            IMAGE.TEMPLATE_IMAGE_FORMAT[settingTemplate][selectedTemplateSet]
        ) {
            selectedTemplateSetFormat = IMAGE.TEMPLATE_IMAGE_FORMAT[settingTemplate][selectedTemplateSet];

            if (imgSplit && imgSplit.length > 0) {
                if (imgSplit[1] !== selectedTemplateSetFormat) {
                    imageSrc = imgSplit[0] + '.' + selectedTemplateSetFormat;
                }
            }
        }

        if (selectedTemplateSet && !window?.imagesTemplate?.disabledTemplate?.[settingTemplate]?.[params.props?.screen?.viewType]?.includes(params?.category)) {
            if (selectedTemplateSetFormat === 'svg') {
                let svgParams = {
                    svgName: params.images.split('.')[0].toUpperCase(),
                    template: params.template,
                    portalSettings: params.portalSettings,
                    index: this.i,
                    screen: params.props.screen.viewType,
                };
                let interval = setInterval(function () {
                    commonUtil.renderTemplateSVG(svgParams).then((resSVG) => {
                        if (resSVG && resSVG.svgData) {
                            let svgDiv;
                            if (params.targetId != null) {
                                svgDiv = document.querySelectorAll('[data-targetid=' + params.targetId + ']');
                            } else {
                                svgDiv = document.querySelectorAll('[id=' + params.images.split('.')[0] + ']');
                            }

                            if (svgDiv) {
                                if (svgDiv.length > 0) {
                                    for (let i = 0; i < svgDiv.length; i++) {
                                        if (svgDiv[i].style) {
                                            svgDiv[i].style.display = params.props.screen.isMobile ? 'flex' : 'block';
                                        }
                                        svgDiv[i].innerHTML = resSVG.svgData;
                                    }
                                }
                            }
                        }
                        clearInterval(interval);
                    });
                }, 0);

                return; // SVG Format will stop here
            } else {
                let imgParams = {
                    template: params.template,
                    type: selectedTemplateSet,
                    fileName: params.className ? params.className : null,
                    category: params.category ? params.category : null,
                    categoryName: commonUtil.getProviderCategoryName(params),
                    images: imageSrc,
                    customImage: params.customImage,
                };
                if (params.imghoverCountryLang) {
                    imageSrc = fallbackSrc;
                } else {
                    hoverImagesSrc = null; // if using templated images then hide hover images
                    imageSrc = commonUtil.getCorrectImagesTemplate(imgParams) || fallbackSrc;
                }
            }
        } else {
            imageSrc = params.customImage ? params.customImage : fallbackSrc;
        }

        if (params.isBackgroundImage) {
            return (
                <div
                    className={params.className ? params.className : null}
                    style={{
                        backgroundImage: `url(${imageSrc}), url(${fallbackSrc})`,
                    }}
                >
                    {commonUtil.renderTemplateInnerClassHtml(params)}
                </div>
            );
        }

        if (imageSrc) {
            if (params.enableSvgImage) {
                // append -svg for classname to prevent use same style
                return (
                    <SVGRenderer
                        category={'SVGSubmenu'}
                        name={params.fallbackImages}
                        className={params.className ? params.className + '-svg' : null}
                        style={params.style ? params.style : {}}
                    />
                );
            } else {
                // for images that cannot work with lazy
                if (params.template === 'provider-banner') {
                    return (
                        <img
                            key={params.index}
                            style={params.style ? params.style : {}}
                            src={imageSrc}
                            onError={(e) => {
                                if (e.target.src !== fallbackSrc) {
                                    e.target.src = fallbackSrc;
                                }
                            }}
                            onMouseEnter={(e) => commonUtil.handleTemplateImgHover(e, hoverImagesSrc)}
                            onMouseLeave={(e) => commonUtil.handleTemplateImgHover(e, hoverImagesSrc ? imageSrc : null)}
                            className={params.className ? params.className : null}
                            alt={params.imageAlt ? params.imageAlt : ''} //{params.template + '.png'}
                        />
                    );
                } else {
                    const useWebP = params.props?.portalSettingsReducer?.portalSettings?.features?.useWebP || (params.props.useWebP || []).indexOf(params.category) > -1;
                    return (
                        <LazyLoadImage
                            key={params.index}
                            src={imageSrc}
                            fallbackSrc={fallbackSrc}
                            useWebP={params.customUseWebP || useWebP}
                            alt={params.imageAlt || ''}
                            style={params.style || {}}
                            className={params.className || null}
                            hoverImagesSrc={hoverImagesSrc}
                            // onMouseEnter={(e) => commonUtil.handleTemplateImgHover(e, hoverImagesSrc)}
                            // onMouseLeave={(e) => commonUtil.handleTemplateImgHover(e, hoverImagesSrc ? imageSrc : null)}
                            notLazyLoad={window.appLayoutV2 ? false : params.notLazyLoad}
                        />
                    );
                }
            }
        } else {
            return <img loading='lazy' alt='emtpy.png' />;
        }
    },

    // Find template set svg and return svg result in html-like string format
    // params = {
    //      portalSettings  => (Required) this.props.portal.settings
    //      svgName         => menus[i].name
    //      template        => The type of template folder name
    //      index           => current requested index to return (solved callback timing issues)
    // }
    // result = {
    //      index           => current requested index to return (solved callback timing issues)
    //      svgData         => the svg' html-like string
    // }
    renderTemplateSVG(params) {
        let res = {
            index: params.index || params.index === 0 ? params.index : null,
            svgData: null,
        };
        let path = null;
        let settingTemplate = null;
        if (params && params.template) {
            settingTemplate = params.template.replace(/-/g, '_').toLowerCase(); // Portal Settings is same name as the template folder name & replace - with _
        }

        return new Promise(function (resolve) {
            let checkType = window?.imagesTemplate?.[settingTemplate]?.[params?.screen];
            if (!checkType) {
                checkType = params.portalSettings && params.portalSettings.images_template && params.portalSettings.images_template[settingTemplate];
            }

            if (settingTemplate && checkType) {
                let imgParams = {
                    template: params.template,
                    type: checkType,
                    images: params.svgName + '.svg',
                };
                path = commonUtil.getCorrectImagesTemplate(imgParams);
            } else if (params.customPath) {
                // some time not necessary take default-whitelabel's images
                path = params.customPath + '/' + params.svgName + '.svg';
                window.SPL_Other.renderTemplateSVG(path, params.svgName).then((data) => {
                    if (data) {
                        res.svgData = data;
                    }
                    resolve(res);
                });
            } else {
                resolve(res);
            }

            window.SPL_JsonSettings.getHTMLbyCache(
                path,
                params.svgName,
                function (file) {
                    if (file) {
                        let svgXML = file.data;
                        if (svgXML) {
                            // remove <?> and <--> tag
                            svgXML = svgXML.split('<?')[0] + svgXML.split('?>')[1];
                            svgXML = svgXML.split('<!--')[0] + svgXML.split('-->')[1];
                            if (svgXML.includes('<style') && svgXML.includes('style>')) {
                                svgXML = svgXML.split('<style')[0] + svgXML.split('style>')[1];
                            }
                            // replace xml key
                            svgXML = core.replaceAll(svgXML, 'xmlns:xlink', 'xmlnsXlink');
                            svgXML = core.replaceAll(svgXML, 'xml:space', 'xmlSpace');
                            svgXML = core.replaceAll(svgXML, 'undefined', '');
                        }
                        res.svgData = svgXML;
                    } else {
                        res.svgData = null;
                    }
                    resolve(res);
                },
                function () {
                    resolve(res);
                }
            );
        });
    },

    renderTemplateInnerClassHtml(params) {
        if (params.innerClassHtml) {
            return params.innerClassHtml;
        }
        return;
    },

    handleTemplateImgHover(e, img) {
        if (img) {
            return (e.target.src = img);
        }
    },

    // Defined default_whitelabel template path
    getCorrectImagesTemplate(params) {
        if (params?.customImage) {
            return params.customImage;
        }
        if (!params?.images) return null;

        let imgPath = '';
        switch (params.template) {
            case 'provider-banner':
            case 'provider-category-landing-banner':
                imgPath = '/public/html/default_whitelabel/template/images/' + params.template + '/' + params.type + '/' + params.categoryName + '/' + params.images;
                break;
            case 'footer-icon':
                imgPath = '/public/html/default_whitelabel/template/images/' + params.template + '/' + params.fileName + '/' + params.type + '/' + params.images;
                break;
            default:
                imgPath = '/public/html/default_whitelabel/template/images/' + params.template + '/' + params.type + '/' + params.images;
                break;
        }
        return imgPath;
    },

    // Convert to category name based on category code
    getProviderCategoryName(params) {
        switch (params.category) {
            case 'C':
                return 'casino';
            case 'SL':
                return 'slot';
            case 'P':
                return 'poker';
            case 'L':
                return 'lottery';
            case 'F':
                return 'fishing';
            case 'S':
                return 'sport';
            case 'ES':
                return 'esport';
            case 'G':
                return '3dgames';
            case 'RC':
                return 'racing';
            case 'CF':
                return 'cockfight';
            case '4D':
                return 'fourD';
            case 'FG':
                return 'fastgames';
            case 'SPS':
                return 'super-sports';
            case 'EC':
                return 'exchange';
            case 'LG':
                return 'livegames';
            case 'TG':
                return 'tvgames';
            case 'NEXS':
                return 'nexshop';
            default:
                return;
        }
    },

    // params = {portalSettings, submenu}
    // props => this.props (required)
    // submenu => selected submenu (required)
    // className => className for the <img /> tag
    getSubmenuImageTag(params, vm) {
        let providerCode = commonUtil.getCorrectProviderCode(params.submenu, params.props.portalSettingsReducer.portalSettings);
        let currencyLang = params?.props?.language?.currencyLang;
        // Special handle for ys8
        if (params.submenu.providerCode === 'IME' && currencyLang === 'VND' && window.merchantCode === 'ys8') {
            providerCode = 'ESP';
            // if using default image from base-menu
            if (params.props.screen.viewType === 'mobile') {
                params.submenu.imgPathPng = params.submenu.imgPathPng.replace('esport', 'esp');
            } else {
                params.submenu.img = params.submenu.img.replace('ime', 'esp');
            }
        }

        let imageSrc = params.submenu.category + '-' + providerCode + '.png';

        let fallbackImages = null;

        if (params.submenu.enableSvgImg) {
            fallbackImages = params.submenu.svgname;
        } else {
            if (params.props.screen.viewType === 'mobile') {
                fallbackImages = gu_proceedNestedObjectWithVM({ props: params.props }, params.submenu.imgPathPng);
            } else {
                //switch landing page bottom default image to other banner in custom-menu while params.isCardBanner = true
                //lotteryIndex04.js, pokerIndex02.js, racing-Index02.js has params.isCardBanner = true
                if (params.isCardBanner) {
                    switch (params.submenu.category) {
                        case 'L':
                            fallbackImages = params.submenu.lotteryBanner;
                            break;
                        case 'RC':
                            fallbackImages = params.submenu.racingBanner;
                            break;
                        case 'P':
                            fallbackImages = params.submenu.pokerBanner;
                            break;
                        default:
                            break;
                    }
                } else {
                    fallbackImages = gu_proceedNestedObjectWithVM({ props: params.props }, params.submenu.img);
                }
            }
        }
        let isChangeHoverImg = false;
        let imghoverCountryLang = false;
        if (params.isChangeHoverImg) {
            isChangeHoverImg = params.isChangeHoverImg;
        }

        let enlargeMenuCount = false;
        if (params.enlargeMenuCount) {
            enlargeMenuCount = params.enlargeMenuCount;
        }

        if (
            params.submenu &&
            params.submenu.imghoverCountryLang &&
            params.submenu.imghoverCountryLang[params.props.language.countryLanguageKey.toLowerCase().replace('_', '-')]
        ) {
            isChangeHoverImg = true;
            imghoverCountryLang = true;
        }
        const isUseCustomImg = gu_proceedNestedObjectWithVM(params, params.submenu.useCustomImg);
        let imgParams = {
            props: params.props,
            portalSettings: params.props.portalSettingsReducer.portalSettings,
            template: params.template ? params.template : 'submenu-icon',
            images: isUseCustomImg && params.template !== 'provider-landing-icon' ? null : imageSrc,
            hoverImages: isChangeHoverImg ? params.submenu.imghover : null,
            imghoverCountryLang: imghoverCountryLang,
            className: params.className,
            fallbackImages: fallbackImages,
            enableSvgImage: params.submenu.enableSvgImg ? true : false,
            style: params.style ? params.style : null,
            category: params.submenu.category,
            targetId: params.targetId ? params.targetId : null,
            enlargeMenuCount: enlargeMenuCount,
            customImage: params.submenu.landingImage || null,
            notLazyLoad: params.notLazyLoad,
            customImagesTemplate: params?.customImagesTemplate,
            customUseWebP: params?.customUseWebP,
        };

        if (params && params.template === 'provider-landing-icon') {
            if (params.submenu.cardBanner) {
                imgParams.fallbackImages = params.submenu.cardBanner;
                imgParams.hoverImages = null;
            } else {
                imgParams.fallbackImages = null;
            }
            if (params.submenu.cardBannerHover) {
                imgParams.hoverImages = params.submenu.cardBannerHover;
            }
            if (params.submenu.providerIcon) {
                imgParams.customImage = params.submenu.providerIcon;
            }
        }

        return commonUtil.renderTemplateImgTag(imgParams, vm);
    },

    // params = { providerCode, name, category }
    // providerCode = provider code
    // name = provider name
    // category = provider category (optional)
    getCorrectProviderCode(submenu, settings) {
        if (submenu) {
            let providerCode = submenu.provider;
            switch (submenu.name) {
                case 'Mega':
                    providerCode = 'MEGA';
                    break;
                case '918Kiss':
                    providerCode = 'SCR2';
                    break;
                case 'QQKenoThai Lottery':
                    providerCode = 'QQKThai';
                    break;
                case 'GamePlay Sode Lottery':
                    if (
                        settings &&
                        settings.features &&
                        settings.features.providerPageSettings &&
                        settings.features.providerPageSettings.lotteryIndex &&
                        settings.features.providerPageSettings.lotteryIndex.enableSubmenuLotterySodeOwnImg
                    ) {
                        providerCode = 'SODE';
                    }
                    break;
                case '4DLottery':
                    if (
                        settings &&
                        settings.features &&
                        settings.features.providerPageSettings &&
                        settings.features.providerPageSettings.lotteryIndex &&
                        settings.features.providerPageSettings.lotteryIndex.enableSubmenuLottery4dOwnImg
                    ) {
                        providerCode = '4DL';
                    }
                    break;
                case '6DLottery':
                    if (
                        settings &&
                        settings.features &&
                        settings.features.providerPageSettings &&
                        settings.features.providerPageSettings.lotteryIndex &&
                        settings.features.providerPageSettings.lotteryIndex.enableSubmenuLottery6dOwnImg
                    ) {
                        providerCode = '6DL';
                    }
                    break;
                case 'SG FishingWar':
                    providerCode = 'SGFW';
                    break;
                case 'SpadeGaming':
                    if (submenu.category === 'F') {
                        providerCode = 'SG2';
                    }
                    break;
                case 'SexyBaccarat2':
                    providerCode = 'UG';
                    break;
                default:
                    break;
            }
            return providerCode;
        } else {
            return null;
        }
    },

    /* template set start */
    getTemplateBannerContainer(params) {
        // let renderImage = commonUtil.getDownloadBannerImage(params, template);
        let renderImage = commonUtil.getTemplateBannerImage(params);
        let renderDesc = commonUtil.getTemplateDesc(params);
        let customContainerParams = {
            portalSettings: params.props.portalSettingsReducer.portalSettings,
            template: params.template,
        };
        let customeBannerClassName = params.className;
        if (params.appendTemplateClassName) {
            customeBannerClassName = commonUtil.appendTemplateClassName(customContainerParams, params.className);
        }

        return (
            <div className={customeBannerClassName}>
                {renderImage}
                {renderDesc}
            </div>
        );
    },

    getTemplateBannerImage(params) {
        let features = params.props.portalSettingsReducer.portalSettings.features;
        let imgSrc = params.customImageName ? params.customImageName : '';
        let isCustomImg = false;
        let languageKey = params.props.language.key;
        switch (params.template) {
            case 'download-banner':
                if (params.useLanguagedBanner) {
                    isCustomImg = true;
                    imgSrc = '/public/html/images/common_img/download-' + languageKey.toLowerCase() + '-bn.png';
                } else {
                    imgSrc = 'download-bn.jpg';
                }
                break;
            case 'provider-banner':
                if (params.props.screen.viewType === 'mobile') {
                    let providerCode =
                        (params.state.provider && params.state.provider.toUpperCase()) || (params.state.currentProvider && params.state.currentProvider.toUpperCase());
                    imgSrc = params.category + '-m-' + providerCode + '.png';

                    //logo
                    if (params.isBottomBanner) {
                        imgSrc = params.category + '-m-' + providerCode + '-highlight.jpg';
                    }
                } else {
                    let providerCode = params.state.provider;
                    // default imgSrc is topBanner
                    // galleryBanner used for provider sub image
                    // isFullScreenBG flag is use for full screen background\
                    // imageSrc means direct take pre-set's name
                    imgSrc = params.category + '-' + providerCode + '.jpg';

                    if (params.isBottomBanner && !params.isFullScreenBG) {
                        imgSrc = params.category + '-' + providerCode + '-highlight.jpg';
                    } else if (params.isGallery) {
                        imgSrc = params.galleryBanner;
                    } else if (params.isFullScreenBG) {
                        imgSrc = params.category + '-' + providerCode + '-bg.jpg';
                    } else if (params.customImageName) {
                        imgSrc = params.customImageName;
                    }

                    if (features && features.defaultBannerFollowProviderBanner && params.defaultProviderBanner) {
                        isCustomImg = true;
                        imgSrc = params.defaultProviderBanner;
                    }
                }
                break;
            case 'provider-category-landing-banner':
                //imageSrc is pre-set name from parameter
                imgSrc = params.category + '-bn.png';

                if (params.state.compSettings && params.state.compSettings.useCustomBanner) {
                    let languageKey = params.props.language.key;
                    let countryLanguageKey = params.props.language.countryLanguageKey;

                    if (params.state.compSettings.useLanguagedBanner) {
                        isCustomImg = true;
                        imgSrc = '/public/html/images/provider_banner/' + params.category + '-' + languageKey.toLowerCase() + '-bn.png';
                    } else if (
                        params.useCountryLanguagedBanner &&
                        params.useCountryLanguagedBanner.length > 0 &&
                        params.useCountryLanguagedBanner.some((countryLang) => countryLanguageKey.includes(countryLang))
                    ) {
                        isCustomImg = true;
                        imgSrc = '/public/html/images/provider_banner/' + params.category + '-' + countryLanguageKey.replace('_', '-').toLowerCase() + '-bn.png';
                    } else if (params.customImagePath) {
                        isCustomImg = true;
                        imgSrc = gu_filterCommonKey(params.customImagePath) || '';
                    }
                } else if (params.state.compSettings.useDefaultBanner) {
                    imgSrc = params.defaultBanner;
                }

                break;
            default:
                break;
        }

        let bannerParams = {
            props: params.props,
            isCustomImg: isCustomImg,
            template: params.template,
            images: imgSrc,
            portalSettings: params.props.portalSettingsReducer.portalSettings,
            isBackgroundImage: params.isBackgroundImage ? params.isBackgroundImage : false,
            className: params.className,
            category: params.category,
            innerClassHtml: params.innerClassHtml ? params.innerClassHtml : false,
            fallbackImages: params.defaultBanner,
            customUseWebP: params?.customUseWebP,
        };

        // special configure the image to not populate template image set
        if (isCustomImg) {
            bannerParams.template = '';
            bannerParams.fallbackImages = imgSrc;
        }

        return commonUtil.renderTemplateImgTag(bannerParams);
    },

    getTemplateFooterImage(param) {
        let imgSrc = param.list + '.png';

        let bannerParams = {
            props: param.props,
            template: param.template,
            images: imgSrc,
            imageAlt: param.list ? param.list : '',
            imagesTemplateSettings: param.props.footerColSettings,
            portalSettings: param.props.portalSettingsReducer.portalSettings,
            className: param.className,
            fallbackImages: param.defaultBanner,
            style: param.style,
            index: param.index,
            hoverImages: param.hoverImages,
            customImage: gu_getNestedValue(param, `customizedContent.${param.list}.img`),
            customUseWebP: param.customUseWebP,
        };
        return commonUtil.renderTemplateImgTag(bannerParams);
    },

    getTemplateDesc(params) {
        if (params.props.screen.viewType !== 'mobile') {
            switch (params.template) {
                case 'download-banner':
                    return downloadBannerDesc(params);
                case 'provider-banner':
                    switch (params.category) {
                        // default returnTopDesc
                        case 'C':
                            if (params.isBottomBanner) {
                                return casinoBottomBannerDesc(params);
                            }
                            return casinoTopBannerDesc(params);
                        case 'SL':
                            return slotTopBannerDesc(params);
                        case 'P':
                            if (params.isBottomBanner) {
                                return pokerBottomBannerDesc(params);
                            }
                            return pokerTopBannerDesc(params);
                        case 'L':
                            return lotteryTopBannerDesc(params);
                        case 'F':
                            if (params.isBottomBanner) {
                                return fishingBottomBannerDesc(params);
                            }
                            return fishingTopBannerDesc(params);
                        case 'S':
                            return sportTopBannerDesc(params);
                        case 'ES':
                            if (params.isBottomBanner) {
                                return esportBottomBannerDesc(params);
                            }
                            return esportTopBannerDesc(params);
                        case 'G':
                            return games3DTopBannerDesc(params);
                        default:
                            break;
                    }
                    break;
                default:
                    break;
            }
        }
    },

    // append the template classname if found the setting template
    appendTemplateClassName(params, defaultClassName) {
        let viewType = null;
        if (isMobile) {
            viewType = 'mobile';
        } else {
            viewType = 'web';
        }
        if (params && params.template) {
            let className = defaultClassName;
            let settingTemplate = params.template.replace(/-/g, '_');

            let checkType = window?.imagesTemplate?.[settingTemplate]?.[viewType];
            if (!checkType) {
                checkType = params.portalSettings && params.portalSettings.images_template && params.portalSettings.images_template[settingTemplate];
            }
            let type = checkType;
            className = className + ' ' + type + '-' + params.template + '-template';
            return className;
        }
    },
    /* template set end */

    getProgressBarData(vm) {
        const { portalSettings } = vm.props.portalSettingsReducer;
        const { user, language, screen, depositProgressBar } = vm.props;
        if (portalSettings && portalSettings.showDepositProgressBar) {
            vm.setState(
                {
                    showDepositProgressBar: portalSettings.showDepositProgressBar,
                    iconLoading: true,
                },
                () => {
                    if (user && user.account) {
                        if (depositProgressBar && depositProgressBar.isUpdated) {
                            loadMemberGroupAutomationSummary(depositProgressBar.details);
                        } else {
                            vm.props
                                .dispatch(consolidateAPIAction.getReferralTypeEnabledAndMemberSummaryGroupAutomation(vm))
                                .then((data) => {
                                    const { memberGroupAutomationSummaryDTO } = data;

                                    loadMemberGroupAutomationSummary(memberGroupAutomationSummaryDTO);
                                })
                                .catch(() => {});
                        }
                    }

                    function loadMemberGroupAutomationSummary(depositProgressBarDetails) {
                        let lang_key = language.key.toLowerCase();
                        window.SPL_Member.loadMemberGroupAutomationSummary(
                            screen.isMobile,
                            user.account.currency,
                            user.account.groupName,
                            user.account.imagePath,
                            lang_key,
                            depositProgressBarDetails
                        ).then((data) => {
                            // this keyword is used for return massaged user level if user level not found. e.g. IT-TESTING
                            let massagedMemberLevel = user.account.groupName;
                            if (data) {
                                if (data.allMemberLevels) {
                                    let allLevels = commonUtil.getContentByCurrencyLanguage(vm, data.allMemberLevels);
                                    if (!allLevels.includes(massagedMemberLevel)) {
                                        massagedMemberLevel = allLevels[0];
                                    }
                                }

                                vm.setState({
                                    progressBarPercentage: data.progressBarPercentage,
                                    memberGroupLevelMessages: data.memberGroupLevelMessages,
                                    userGroupImage: data.userGroupImage,
                                    userReviewDate: data.reviewDate,
                                    depositProgress: data.depositProgress,
                                    iconLoading: false,
                                    generalTranslation: data.generalTranslation && commonUtil.getContentByCurrencyLanguage(vm, data.generalTranslation),
                                    massagedMemberLevel: massagedMemberLevel,
                                    upgradeGroupName: data.upgradeGroupName,
                                    totalDeposit: data.totalDeposit,
                                    upgradeTotalDeposit: data.upgradeTotalDeposit,
                                    maintainTotalDeposit: data.maintainTotalDeposit,
                                    allMemberLevels: gu_getContentByCurrencyLanguage(vm, data.allMemberLevels),
                                });
                            } else {
                                vm.setState({
                                    iconLoading: false,
                                    massagedMemberLevel: massagedMemberLevel,
                                });
                            }
                        });
                    }
                }
            );
        }
    },

    getUserSeamlessStatus(vm) {
        // moved to member-util
        return mu_getUserSeamlessStatus(vm);
    },

    // getMainWallet(vm) {
    //     const { user } = vm.props;
    //     if (user && user.isLogin && !window.isAffiliate) {
    //         vm.setState({ restoreOnLoad: true });
    //         window.SPL_Member.getMainWallet().then((mainWallet) => {
    //             mainWallet.data.currency = vm.props.user.account.currency;
    //             vm.setState(
    //                 {
    //                     mainWallet: mainWallet.data,
    //                     restoreOnLoad: false,
    //                 },
    //                 () => {
    //                     memberService.loadProviders(vm);
    //                 }
    //             );
    //         });
    //     }
    // },

    updateMainWalletInProps(vm, callback) {
        window.SPL_Member.getMainWallet().then((mainWallet) => {
            vm.props.dispatch(walletAction.updateWallet(mainWallet.data));
            callback && callback(mainWallet);
        });
    },

    updateMissionClaimCount(dispatch, claim, byCategory = false) {
        if (byCategory) {
            dispatch(userAction.updateMissionClaimCountByCategory(claim));
        } else {
            dispatch(userAction.updateMissionClaimCount(claim));
        }
    },

    updateIsBalanceMasked(vm, isBalanceMasked) {
        window.SPL_Cookie.setCookie('isBalanceMasked', isBalanceMasked, 30);
        vm.props.dispatch(userAction.updateIsBalanceMasked(isBalanceMasked));
    },

    updateUserSeamless(vm) {
        return gu_updateUserSeamless(vm); // moved to general-util.js
    },

    restoreWallet(vm) {
        const { seamless } = vm.props;
        vm.setState({ restoreOnLoad: true });
        window.SPL_Transaction.transferAllBackMainWallet()
            .then(() => {
                if (seamless?.isSeamless) {
                    mu_getSeamlessMemberWallet(vm);
                    commonUtil.getMainWallet(vm);
                } else {
                    commonUtil.getMainWallet(vm);
                }
            })
            .catch(() => {
                if (seamless?.isSeamless) {
                    mu_getSeamlessMemberWallet(vm);
                    commonUtil.getMainWallet(vm);
                } else {
                    commonUtil.getMainWallet(vm);
                }
            });
    },

    getCorrectSettingUrl() {
        let settingTemplate = window.settingTemplate;
        if (settingTemplate && settingTemplate === 'settings02') {
            return '/myaccount/myprofile';
        } else {
            return '/myaccount/profile';
        }
    },

    handleControllerOnClick(url, user = false, livechatSettings = false) {
        const contactObj = {
            name: 'LiveChat',
            desc: url,
        };

        window.SPL_Content.getContactUrl(contactObj, false, user, livechatSettings);
    },

    contactOnClick(vm, contact, isHref, livechatSettings = false) {
        const { user, portalSettingsReducer, language, screen, viewType } = vm.props; // , language, screen, viewType
        const { features } = portalSettingsReducer.portalSettings;

        if (contact?.internalUrl) {
            if (contact.isRequireLogin && !user?.isLogin) {
                vm.props.dispatch(portalAction.showLoginAlert(true));
            } else {
                vm.props.history.push(contact.internalUrl);
            }

            return;
        }

        let tempViewType = viewType;
        if (screen?.viewType) {
            tempViewType = screen?.viewType;
        }

        // Handle special case for LiveChat
        if (features?.liveChatToLine && contact.name === 'LiveChat') {
            const lineContact = vm.state.contactList.find((c) => c.name === 'Line');
            if (lineContact) {
                contact = lineContact;
            }
        }

        const { specialURL } = contact;
        const contactParam = window.SPL_Other.deepCopy(contact);

        if (contactParam.redirectName) {
            contactParam.name = contactParam.redirectName;
        }

        function getContactUrl() {
            return window.SPL_Content.getContactUrl(contactParam, false, user, livechatSettings);
        }

        function fetchContactList() {
            return gu_getContactList(language?.countryLanguageKey, tempViewType, 2)
                .then((contactList) => {
                    if (contactList) {
                        const findKey = contact?.key ? 'key' : 'name';
                        const contactSelected = contactList.find((contactJsonList) => contactJsonList?.[findKey] === contact?.[findKey]);
                        return contactSelected?.url?.startsWith('https') ? contactSelected?.url : getContactUrl();
                    }
                })
                .catch((error) => {
                    console.error('Error fetching contact list:', error);
                    return null;
                });
        }

        const finalUrlPromise = isHref || specialURL ? Promise.resolve(isHref || specialURL) : fetchContactList();

        // const finalUrl = isHref || specialURL ? isHref || specialURL : contact.url;

        finalUrlPromise.then((url) => {
            if (url) {
                gu_triggerAdElementAction('onUrlClick', {
                    login: window.lh_ml,
                    url: url,
                    contactType: contact.name,
                    viewType: gu_getNestedValue(vm.props, 'screen.viewType') || gu_getNestedValue(vm.props, 'oriProps.screen.viewType'),
                });
                gu_postExternalCampainPostback(contact, url);
                if (contact.name === 'LiveChat') {
                    const customLivechatAction = gu_proceedNestedObjectWithVM(vm, features?.customLivechatAction) || {};
                    if (customLivechatAction?.action === 'runCustomEventScriptsFunction') {
                        return getContactUrl();
                    }
                }
                window.open(url);
            } else {
                console.error('No URL found for the contact.');
            }
        });
    },
    handleStatusTranslate(status) {
        switch (status) {
            case 'P':
                return 'pending';
            case 'I':
                return 'inProgress';
            case 'A':
                return 'accepted';
            case 'R':
                return 'rejected';
            default:
                return status;
        }
    },

    convertStringToDate(_date, _format, _delimiter) {
        let formatLowerCase = _format.toLowerCase();
        let formatItems = formatLowerCase.split(_delimiter);
        let dateItems = _date.split(_delimiter);
        let monthIndex = formatItems.indexOf('mm');
        let dayIndex = formatItems.indexOf('dd');
        let yearIndex = formatItems.indexOf('yyyy');
        let month = parseInt(dateItems[monthIndex]);
        month -= 1;
        let formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
        return formatedDate;
    },

    // eb88 template landing page submenu logic
    submenuBasedOnLandingOnClick(vm, menuObj, callback = () => {}) {
        const { screen, history } = vm.props;
        // const { showSubmenu, selectedSubmenuType } = vm.state;
        // if is LaunchGameFromLanding will direct start game, else redirect
        if (menuObj.isLaunchGameFromLanding) {
            //here open modal for task SUP-14401
            provider.launchGameFromMenu(menuObj, vm.props.language, vm.props.user.isLogin, vm.props.screen, vm.props, true);
        } else {
            // 1. check special case that need direct redirect
            // 2. check isNavigate, and based on web/mobile
            if (menuObj.name.includes('Mega') || menuObj.name.includes('918Kiss') || menuObj.name.includes('918Kiss2') || menuObj.name.includes('Pussy888')) {
                history.push(menuObj.route);
            } else if (menuObj.name.includes('Affiliate')) {
                commonUtil.affiliateNavigate(vm.state.affiliateLink, vm);
            } else {
                if (screen.isMobile) {
                    if (menuObj.directUrl) {
                        window.open(menuObj.directUrl, '_blank');
                    } else {
                        history.push(menuObj.route);
                    }
                } else {
                    if (menuObj.landingRoute) {
                        history.push({
                            pathname: menuObj.landingRoute,
                            state: {
                                from: history.location.pathname,
                                to: menuObj.landingRoute,
                            },
                        });
                    }
                }
            }

            callback();

            // if (showSubmenu || selectedSubmenuType === menuObj.name) {
            //     vm.setState({ showSubmenu: false, selectedSubmenuType: '', hoverSubmenuName: '' });
            // }
        }
    },

    getSubmenuLandingPage(category, portalSettingsReducer) {
        let mainRouteSettings = portalSettingsReducer?.portalSettings?.features?.mainRouteSettings;

        switch (category) {
            case mainRouteSettings && mainRouteSettings.customSlotIndexComponentPath && 'SL':
                return mainRouteSettings.customSlotIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customCasinoIndexComponentPath && 'C':
                return mainRouteSettings.customCasinoIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customCasinoComponentPath && 'C':
                return mainRouteSettings.customCasinoComponentPath;
            case mainRouteSettings && mainRouteSettings.customSportIndexComponentPath && 'S':
                return mainRouteSettings.customSportIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customESportIndexComponentPath && 'ES':
                return mainRouteSettings.customESportIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customLotteryIndexComponentPath && 'L':
                return mainRouteSettings.customLotteryIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.custom4DIndexComponentPath && 'FD':
                return mainRouteSettings.custom4DIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customFishingIndexComponentPath && 'F':
                return mainRouteSettings.customFishingIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customGamesIndexComponentPath && 'G':
                return mainRouteSettings.customGamesIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customGamesComponentPath && 'G':
                return mainRouteSettings.customGamesComponentPath;
            case mainRouteSettings && mainRouteSettings.customCockfightIndexComponentPath && 'CF':
                return mainRouteSettings.customCockfightIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customPokerIndexComponentPath && 'P':
                return mainRouteSettings.customPokerIndexComponentPath;
            case mainRouteSettings && mainRouteSettings.customExchangeIndexComponentPath && 'EC':
                return mainRouteSettings.customExchangeIndexComponentPath;
            case mainRouteSettings?.customLiveGamesIndexComponentPath && 'LG':
                return mainRouteSettings.customLiveGamesIndexComponentPath;
            case mainRouteSettings?.customTVGamesIndexComponentPath && 'TG':
                return mainRouteSettings.customTVGamesIndexComponentPath;
            case mainRouteSettings?.customBingoIndexComponentPath && 'B':
                return mainRouteSettings.customBingoIndexComponentPath;
            case mainRouteSettings?.customFastGamesComponentPath && 'FG':
                return mainRouteSettings.customFastGamesComponentPath;
            case 'SL':
                return '/slots-landing';
            case 'C':
                return '/casino-landing';
            case 'S':
                return '/sports-landing';
            case 'ES':
                return '/esports-landing';
            case 'L':
                return '/lottery-landing';
            case 'FD':
                return '/4d-landing';
            case 'F':
                return '/fishing';
            case 'G':
                return '/games-landing';
            case 'CF':
                return '/cockfight-landing';
            case 'P':
                return '/poker-landing';
            case 'FG':
                return '/fastgames-landing';
            case 'EC':
                return '/exchange-landing';
            case 'LG':
                return '/livegames-landing';
            case 'TG':
                return '/tvgames-landing';
            case 'B':
                return '/bingo-landing';
            default:
                return '/';
        }
    },

    // funtion to handle redirect or open in new tab
    commonHrefRedirect(url, vm) {
        gu_commonHrefRedirect(url, vm);
    },

    handleTabScroll(config, direction) {
        const { displaySubmenu, scrollLeftMilestones, scrollRightMilestones, fullVisibleProvider, providerRef, containerScrollRef, containerScroll, noHalfProvider } = config;
        const ref = containerScroll ? containerScroll : containerScrollRef;

        const oneProviderSize = providerRef.current && providerRef.current.clientWidth;
        const halfProviderSize = noHalfProvider ? oneProviderSize : oneProviderSize / 2;

        const steps = displaySubmenu.length - fullVisibleProvider;

        /**
         * NOTE:
         * issue: when actual ref's width had decimal value (rem responsive), cause unable to scroll issue.
         * browser calculation for scrolling might have decimal offset, hence min & max both will +1 -1 instead of 0 as the offset range.
         */
        let min = 1;
        let max = (displaySubmenu.length - (fullVisibleProvider + 1)) * oneProviderSize + halfProviderSize - 1;

        const leftMilestones = scrollLeftMilestones;
        const rightMilestones = scrollRightMilestones;
        if (direction === 'left') {
            let leftMilestone = 0;
            for (let i = 0, l = steps; i < l; i++) {
                if (ref.current.scrollLeft - leftMilestones[i] <= min) {
                    break;
                }
                leftMilestone = leftMilestones[i];
            }

            if (ref.current.scrollLeft <= min) {
                // ref.current.scrollLeft = min;
            } else {
                ref.current.scrollTo(leftMilestone, 0);
            }
        } else if (direction === 'right') {
            let rightMilestone = 0;
            for (let i = 0, l = steps; i < l; i++) {
                if (rightMilestones[i] - ref.current.scrollLeft > min) {
                    rightMilestone = rightMilestones[i];
                    break;
                }
            }

            if (ref.current.scrollLeft >= max) {
                // ref.current.scrollLeft = max;
            } else {
                ref.current.scrollTo(rightMilestone, 0);
            }
        }
        // console.log('scroll: ' + ref.current.scrollLeft);
    },

    initTabScrollMilestones(config) {
        const { displaySubmenu, scrollLeftMilestones, scrollRightMilestones, fullVisibleProvider, providerRef, isMobile, noHalfProvider } = config;

        const leftMilestones = scrollLeftMilestones;
        const rightMilestones = scrollRightMilestones;

        if ((leftMilestones.length !== 0 && rightMilestones.length !== 0) || displaySubmenu.length === 0) return;

        const oneProviderSize = providerRef.current && providerRef.current.clientWidth;
        const halfProviderSize = noHalfProvider ? oneProviderSize : oneProviderSize / 2;

        const steps = displaySubmenu.length - fullVisibleProvider;

        if (oneProviderSize) {
            for (let i = 0, l = steps; i < l; i++) {
                let value = 0;
                if (i === 0) {
                    value = 0;
                } else {
                    value = oneProviderSize + leftMilestones[i - 1];
                }
                leftMilestones.push(value);
            }

            for (let i = 0, l = steps; i < l; i++) {
                let value = 0;
                if (isMobile) {
                    if (i === 0) {
                        value = halfProviderSize;
                    } else if (i === l - 1) {
                        value = oneProviderSize + rightMilestones[i - 1] + halfProviderSize;
                    } else {
                        value = oneProviderSize + rightMilestones[i - 1];
                    }
                } else {
                    if (i === 0) {
                        value = halfProviderSize;
                    } else {
                        value = oneProviderSize + rightMilestones[i - 1];
                    }
                }
                rightMilestones.push(value);
            }

            // console.log("leftmilestones: " + leftMilestones);
            // console.log("rightmilestones: " + rightMilestones);
        }
    },

    updateTabScrollInitPos(config) {
        const {
            displaySubmenu,
            provider,
            scrollLeftMilestones,
            scrollRightMilestones,
            containerScrollRef,
            containerScroll,
            fullVisibleProvider,
            initPosUpdated,
            setInitPosUpdated,
        } = config;
        const ref = containerScroll ? containerScroll : containerScrollRef;

        if (!initPosUpdated) {
            const leftMilestones = scrollLeftMilestones;
            const rightMilestones = scrollRightMilestones;

            if (leftMilestones.length !== 0 && rightMilestones.length !== 0 && ref.current) {
                let providerIndex = 0;
                displaySubmenu.map((element, index) => {
                    if (provider === element.provider) providerIndex = index;
                    return element;
                });

                let initialPos = 0;
                if (providerIndex < displaySubmenu.length - fullVisibleProvider) initialPos = leftMilestones[providerIndex];
                else initialPos = rightMilestones[rightMilestones.length - 1];

                ref.current.scrollLeft = initialPos;

                setInitPosUpdated && setInitPosUpdated();
            }
        }
    },

    updateTabScrollPosOnProviderClicked(config) {
        const {
            displaySubmenu,
            provider,
            scrollLeftMilestones,
            scrollRightMilestones,
            fullVisibleProvider,
            containerScrollRef,
            containerScroll,
            providerRef,
            providerIndex,
            noHalfProvider,
        } = config;
        const ref = containerScroll ? containerScroll : containerScrollRef;

        if (ref.current) {
            const oneProviderSize = providerRef.current && providerRef.current.clientWidth;
            const halfProviderSize = noHalfProvider ? oneProviderSize : oneProviderSize / 2;

            let initialPos = 0;
            const leftMilestones = scrollLeftMilestones;
            const rightMilestones = scrollRightMilestones;

            let providerIdx = providerIndex;
            if (providerIdx === undefined) {
                displaySubmenu.map((element, index) => {
                    if (provider === element.provider) providerIdx = index;
                    return element;
                });
            }

            if (providerIdx < displaySubmenu.length - fullVisibleProvider) initialPos = leftMilestones[providerIdx];
            else initialPos = rightMilestones[rightMilestones.length - 1];

            const virualInitPos = oneProviderSize * providerIdx;
            const withinRange = oneProviderSize * fullVisibleProvider - halfProviderSize;

            const leftCondition = initialPos - ref.current.scrollLeft < 0;
            const rightCondition = virualInitPos - ref.current.scrollLeft > withinRange;

            if (ref.current.scrollLeft !== initialPos && (leftCondition || rightCondition)) {
                ref.current.scrollTo({ left: initialPos, top: 0, behavior: 'smooth' });
                // console.log("update pos based on provider: " + initialPos);
            }
        }
    },

    // deposit and transfer only
    initCheckLiteAppUrl(vm) {
        const pathName = vm.props.portal.pathname;

        if (!window.isAgent && !window.isAffiliate) {
            if (window.SPL_LiteApp.isLiteApp()) {
                if (pathName.indexOf('liteapp') !== -1) {
                    vm.setState({
                        isLiteAppUrl: true,
                    });
                }
            } else if (pathName.includes('liteapp')) {
                vm.setState({
                    isLiteAppUrl: true,
                });
            }
        }
    },

    initCheckLiteAppLoginData(vm) {
        if (!window.isAgent && !window.isAffiliate) {
            if (window.SPL_LiteApp.isLiteApp()) {
                if (window.SPL_LiteApp.isLoginDataExist()) {
                    vm.setState({
                        isLiteAppLoginData: true,
                    });
                }
            }
        }
    },

    onBiometricIconClicked(mode) {
        if (!window.isAgent && !window.isAffiliate) {
            if (window.SPL_LiteApp.isLiteApp()) {
                window.SPL_LiteApp.onBiometricAuthenticationTapped(mode);
            }
        }
    },

    initCheckLiteAppBioMode(vm) {
        if (!window.isAgent && !window.isAffiliate) {
            if (window.SPL_LiteApp.isLiteApp()) {
                let bioMode = '';
                if (window.SPL_LiteApp.isTouchBioAuthUnlocked()) {
                    bioMode = 'TouchID';
                } else if (window.SPL_LiteApp.isFaceBioAuthUnlocked()) {
                    bioMode = 'FaceID';
                }
                vm.setState({
                    bioMode,
                });
            }
        }
    },

    getContentByCurrencyLanguage(vm, content, countryLanguageKeySettings = {}) {
        return gu_getContentByCurrencyLanguage(vm, content, countryLanguageKeySettings); // moved to general-util.js
    },

    handleDynamicContentStyling(object, key, styleKey = null, maxRow = null, maxCol = null) {
        let resObject = object;

        if (resObject) {
            let objStyle = resObject.style;
            if (styleKey) {
                objStyle = resObject[styleKey];
            }

            if (objStyle) {
                // maximum 12 row
                for (let i = 0; i < (maxRow ? maxRow : 12); i++) {
                    if (objStyle[key + i]) {
                        if (objStyle[key]) {
                            objStyle[key + i] = commonUtil.jsonConcat(objStyle[key], objStyle[key + i]);
                        }
                    } else {
                        objStyle[key + i] = objStyle[key] ? objStyle[key] : {};
                    }

                    // maximum 1 row 16 col
                    for (let j = 0; j < (maxCol ? maxCol : 16); j++) {
                        objStyle[key + i + 'Col' + j] = commonUtil.jsonConcat(
                            objStyle[key + 'Col'] ? objStyle[key + 'Col'] : {},
                            commonUtil.jsonConcat(
                                objStyle[key + i + 'Col'] ? objStyle[key + i + 'Col'] : {},
                                objStyle[key + i + 'Col' + j] ? objStyle[key + i + 'Col' + j] : {}
                            )
                        );
                    }
                }
            }
        }

        return resObject;
    },

    // combine 2 json into 1
    jsonConcat(json1, json2, vm) {
        return gu_jsonConcat(json1, json2, vm); // moved to general-util.js
    },

    toggleShareButton(selectedKey, vm, fromProps = false) {
        // remove invisible back screen first
        const backscreenToRemove = document.getElementById('shareDropdownBackScreen');
        if (backscreenToRemove) {
            backscreenToRemove.remove();
        }

        let shareOpen = !fromProps ? vm.state.shareOpen : vm.props.shareOpen;
        let isSetTrue = false;
        for (let key in shareOpen) {
            if (key === selectedKey && !shareOpen[selectedKey]) {
                shareOpen[selectedKey] = true;
                isSetTrue = true;
            } else {
                shareOpen[key] = false;
            }
        }

        // add invisible back screen to toggle button when click other side
        if (isSetTrue) {
            const backscreen = document.createElement('div');
            backscreen.className = 'share-dropdown-back-screen';
            backscreen.id = 'shareDropdownBackScreen';
            backscreen.onclick = function () {
                commonUtil.toggleShareButton(selectedKey, vm, fromProps);
            };
            document.getElementById('root').appendChild(backscreen);
        }

        vm.setState({ shareOpen });
    },

    getCmdLiveMatchInfo(vm) {
        const { language } = vm.props;

        window.SPL_Content.getCmdLiveMatchInfo(language.key).then((data) => {
            vm.setState({ liveTVList: data });
        });
    },

    inWords(num) {
        return gu_inWords(num);
    },

    affiliateNavigate(url, vm, target = null) {
        const { features } = vm.props.portalSettingsReducer.portalSettings;
        if (features && features.redirectCurrentCuurency) {
            const defaultPage = features?.redirectToAffPage || '/home';
            window.open(url + `${defaultPage}?lang=` + window.localStorage.LANGUAGE_CURRENCY); // add / home to fix domain can't detect params
            window.localStorage.setItem('LANGUAGE_CURRENCY', window.localStorage.LANGUAGE_CURRENCY);
        } else {
            window.open(url, target ? target : '_blank');
        }
    },

    getAppLandingData(vm, isQrCodeData) {
        const { language, screen, portal } = vm.props;
        const isDownloadAppV2 = portal?.settings?.features?.enableAppDownloadV2;
        const hostName = window.location.host;
        if (isDownloadAppV2) return Promise.resolve();
        return new Promise(function (resolve, reject) {
            window.SPL_Content.getDefaultAppDownloadTranslation()
                .then(function (defaultTranslation) {
                    window.SPL_Content.getAppLandingDataSp2()
                        .then((res) => {
                            if (res) {
                                const {
                                    appDownloadData = null,
                                    appDownloadDataTranslation,
                                    appDownloadStyling,
                                    camouflageAppDownloadData = null,
                                    camouflageAppDownloadDataTranslation,
                                    imageTutorial,
                                } = res;
                                let _appDownloadData = JSON.parse(JSON.stringify(appDownloadData));
                                let _camouflageAppDownloadData = JSON.parse(JSON.stringify(camouflageAppDownloadData));

                                window.SPL_JsonSettings.getAppDownloadLinkJson((data) => {
                                    let iosDownloadLink = '';
                                    let androidDownloadLink = '';
                                    let camoiosDownloadLink = '';
                                    let camoAndroidDownloadLink = '';
                                    let affCode = window.SPL_Cookie.getCookie('AffCode');
                                    const hideAppTab = appDownloadData?.hideAppTab || appDownloadData?.hideTabByDomain?.[hostName];

                                    if (data) {
                                        if (data.ios) {
                                            if (data.iosLanguage && data.iosLanguage[language.key]) {
                                                iosDownloadLink = data.iosLanguage[language.key];
                                            } else {
                                                iosDownloadLink = gu_getContentByCurrencyLanguage(vm, data.ios);
                                            }
                                        }

                                        if (data.android) {
                                            androidDownloadLink = gu_getContentByCurrencyLanguage(vm, data.android);
                                        }
                                    }

                                    if (data && data.camouflageapp) {
                                        let camoData = data.camouflageapp;
                                        if (camoData.ios) {
                                            if (camoData.iosLanguage && camoData.iosLanguage[language.key]) {
                                                camoiosDownloadLink = camoData.iosLanguage[language.key];
                                            } else {
                                                camoiosDownloadLink = gu_getContentByCurrencyLanguage(vm, camoData.ios);
                                            }
                                        }

                                        if (camoData.android) {
                                            camoAndroidDownloadLink = gu_getContentByCurrencyLanguage(vm, camoData.android);
                                        }
                                    }

                                    // handle dynamic link
                                    iosDownloadLink = core.replaceAll(iosDownloadLink, '<affiliate ID>', affCode);
                                    androidDownloadLink = core.replaceAll(androidDownloadLink, '<affiliate ID>', affCode);
                                    camoiosDownloadLink = core.replaceAll(camoiosDownloadLink, '<affiliate ID>', affCode);
                                    camoAndroidDownloadLink = core.replaceAll(camoAndroidDownloadLink, '<affiliate ID>', affCode);
                                    _appDownloadData.apkDownloadLink = androidDownloadLink = core.replaceAll(
                                        gu_getContentByCurrencyLanguage(vm, _appDownloadData.apkDownloadLink),
                                        '<affiliate ID>',
                                        affCode
                                    );
                                    if (_camouflageAppDownloadData) {
                                        _camouflageAppDownloadData.apkDownloadLink = camoAndroidDownloadLink = core.replaceAll(
                                            gu_getContentByCurrencyLanguage(vm, _camouflageAppDownloadData.apkDownloadLink),
                                            '<affiliate ID>',
                                            affCode
                                        );
                                    }

                                    let appTabVisible = true;
                                    if (!window.isAgent && !window.isAffiliate) {
                                        if (window.SPL_LiteApp.isLiteApp() || window.SPL_WebApp.isWebAppBool()) {
                                            appTabVisible = false;
                                        }
                                    }

                                    if (hideAppTab || !appDownloadData.currency.every((e) => e !== language.currencyLang)) {
                                        appTabVisible = false;
                                    }

                                    let _tabList = appDownloadData.tabList;
                                    if (Array.isArray(_tabList) && _tabList.length > 0) {
                                        _tabList = _tabList.filter((item) => {
                                            return !item?.hideTabByDomain?.[hostName];
                                        });

                                        if (
                                            _appDownloadData &&
                                            (!_appDownloadData.apkDownloadLink || _appDownloadData.apkDownloadLink === '') &&
                                            (!iosDownloadLink || iosDownloadLink === '')
                                        ) {
                                            _tabList = _tabList.filter((item) => item.tabName !== 'liteapp');
                                            _appDownloadData.mainActiveTab = _tabList[0].tabName;
                                        }
                                        if (
                                            _camouflageAppDownloadData &&
                                            (!_camouflageAppDownloadData.apkDownloadLink || _camouflageAppDownloadData.apkDownloadLink === '') &&
                                            (!camoiosDownloadLink || camoiosDownloadLink === '')
                                        ) {
                                            _tabList = _tabList.filter((item) => item.tabName !== 'camouflageapp');
                                            _appDownloadData.mainActiveTab = _tabList[0].tabName;
                                        }

                                        _appDownloadData.tabList = _tabList;
                                    }

                                    const commonStateObject = {
                                        appDownloadData: _appDownloadData,
                                        // app-download.json content → default translated content → English content
                                        appDownloadDataTranslation: !isEmpty(
                                            gu_getContentByCurrencyLanguage(vm, appDownloadDataTranslation, { disableDefaultTranslate: true })
                                        )
                                            ? gu_getContentByCurrencyLanguage(vm, appDownloadDataTranslation)
                                            : gu_getContentByCurrencyLanguage(vm, defaultTranslation?.appDownloadDataTranslation),
                                        camouflageAppDownloadData: _camouflageAppDownloadData,
                                        camouflageAppDownloadDataTranslation: !isEmpty(
                                            gu_getContentByCurrencyLanguage(vm, camouflageAppDownloadDataTranslation, {
                                                disableDefaultTranslate: true,
                                            })
                                        )
                                            ? gu_getContentByCurrencyLanguage(vm, camouflageAppDownloadDataTranslation)
                                            : gu_getContentByCurrencyLanguage(vm, defaultTranslation?.camouflageAppDownloadDataTranslation),
                                        appDownloadStyling: appDownloadStyling && appDownloadStyling[screen.viewType],
                                        appTabVisible,
                                        iosDownloadLink,
                                        androidDownloadLink,
                                        camoiosDownloadLink,
                                        camoAndroidDownloadLink,
                                        imageTutorial: !isEmpty(gu_getContentByCurrencyLanguage(vm, imageTutorial, { disableDefaultTranslate: true }))
                                            ? gu_getContentByCurrencyLanguage(vm, imageTutorial)
                                            : gu_getContentByCurrencyLanguage(vm, defaultTranslation?.imageTutorial),
                                        iosRegionApp: gu_filterCommonKey(res, 'iosRegionApp', { baseOnUserCurrency: true }),
                                    };

                                    // NOTE: full link surely /public/html/XXX, created for in house such as BETA.
                                    let iosDownloadLinkFull = _appDownloadData.isIOSRedirect ? iosDownloadLink : _appDownloadData.iosDownloadLink;

                                    if (iosDownloadLinkFull) {
                                        if (!iosDownloadLinkFull.startsWith('http')) {
                                            iosDownloadLinkFull = new URL(iosDownloadLinkFull, window.location.origin).href;
                                        } else if (iosDownloadLinkFull.includes('/redirect-liteapp?liteapp=iosDL')) {
                                            iosDownloadLinkFull = new URL('/redirect-liteapp?liteapp=iosDL&getFromJson=true', window.location.origin).href;
                                        }
                                    }

                                    let apkDownloadLink = _appDownloadData.isAndroidRedirect ? androidDownloadLink : _appDownloadData.apkDownloadLink;
                                    const qrStateObject = {
                                        apkDownloadLinkFull:
                                            (!apkDownloadLink.includes('https') && !apkDownloadLink.includes('http') ? window.location.origin : '') + apkDownloadLink,
                                        iosDownloadLinkFull: iosDownloadLinkFull,
                                        currentMobileOs: window.SPL_Other.getMobileOS(),
                                    };

                                    const stateObject = Object.assign(commonStateObject, isQrCodeData ? qrStateObject : {});
                                    vm.setState(stateObject, () => {
                                        resolve(stateObject);
                                    });
                                });
                            }
                        })
                        .catch(() => {
                            reject();
                        });
                })
                .catch(() => {
                    reject();
                });
        });
    },

    getSettingFromPortalSettings(params) {
        return gu_getSettingFromPortalSettings(params);
    },

    getFeaturesFromPortalSettings(vm, isAffFeatures = false) {
        return gu_getFeaturesFromPortalSettings(vm, isAffFeatures);
    },

    // vm -> this
    // componentName -> the component's prop name
    // propAndValues -> the updated data to be assigned back to the component
    updateComponentProps(vm, componentName, propAndValues, callback) {
        return gu_updateComponentProps(vm, componentName, propAndValues, callback);
    },

    getPortalContentCache(vm, requiredContent, key, callback) {
        if ((requiredContent && requiredContent[key]) || window.templateCode === 'ss2') {
            window.SPL_Content.getPortalContentCache(key).then((res) => {
                if (res) {
                    let _portalContentCache = {};
                    _portalContentCache[key] = res;
                    switch (Object.keys(_portalContentCache)[0]) {
                        case 'casino-content':
                            commonUtil.getCasinoContentCache(vm, _portalContentCache, key, callback);
                            break;
                        default:
                            vm.setState({ portalContentCache: _portalContentCache }, () => {
                                callback && callback();
                            });
                            break;
                    }
                }
            });
        } else {
            callback && callback();
        }
    },

    getCasinoContentCache(vm, data, key, callback) {
        let portalContentCache = vm.state.portalContentCache;
        portalContentCache[key] = {};

        const { provider } = vm.state;
        if (data[key]) {
            let casinoContent = data[key];

            portalContentCache[key].displayTab = commonUtil.getContentByCurrencyLanguage(vm, casinoContent.displayTab);
            portalContentCache[key].winnerList = commonUtil.getContentByCurrencyLanguage(vm, casinoContent.winnerList);
            portalContentCache[key].winnerCarouselSettings = commonUtil.getContentByCurrencyLanguage(vm, casinoContent.winnerCarouselSettings);
            if (casinoContent.dummyList && casinoContent.dummyList[provider]) {
                portalContentCache[key].dummyList = commonUtil.getContentByCurrencyLanguage(vm, casinoContent.dummyList[provider]);
            }
            if (casinoContent.providerVideo && casinoContent.providerVideo[provider]) {
                portalContentCache[key].providerVideo = casinoContent.providerVideo[provider];
            } else if (casinoContent.providerVideo && casinoContent.providerVideo['ALL']) {
                portalContentCache[key].providerVideo = casinoContent.providerVideo['ALL'];
            }

            portalContentCache[key].showItemOverlay = !!casinoContent.showItemOverlay?.[provider];

            if (casinoContent.generalTranslation) {
                portalContentCache[key].generalTranslation = {};
                for (let jsonKey in casinoContent.generalTranslation) {
                    portalContentCache[key].generalTranslation[jsonKey] = commonUtil.getContentByCurrencyLanguage(vm, casinoContent.generalTranslation[jsonKey]);
                }
            }
        }
        vm.setState({ portalContentCache }, () => {
            callback && callback();
        });
    },

    toggleDialog(vm, dialogType, defaultTab, os) {
        const { downloadPopupIsShow } = vm.state;
        const { portalSettingsReducer, history } = vm.props;

        switch (dialogType) {
            case 'download':
                if (portalSettingsReducer && portalSettingsReducer.portalSettings && portalSettingsReducer.portalSettings.homeSettings) {
                    if (portalSettingsReducer.portalSettings.homeSettings.redirectExternalUrl) {
                        return gu_commonHrefRedirect(portalSettingsReducer.portalSettings.homeSettings.redirectExternalUrl, vm);
                    }
                    if (portalSettingsReducer.portalSettings.homeSettings.appDownloadRedirect) {
                        return history.push('/download');
                    }
                }
                vm.setState({ downloadPopupIsShow: !downloadPopupIsShow, defaultTab: defaultTab, activeTab: os });
                break;
            default:
                break;
        }
    },

    changeLanguageArrangementSort(languageModalOrdering, list) {
        return gu_changeLanguageArrangementSort(languageModalOrdering, list);
    },

    orderArray(array_with_order, array_to_order) {
        gu_orderArray(array_with_order, array_to_order);
    },

    // Simple function to get JSON by view type, will fallback return original obj if view type not found
    // obj -> the obj/json needed to handle, viewType is obj['web'] / obj['mobile']
    // vm -> this
    getByViewType(obj, vm) {
        return gu_getByViewType(obj, vm); // moved to general-util.js
    },

    //dropdownDispatch
    dropdownUpdate(e = false, item = false, props = false, state = null, hide = null, autoRender = false) {
        return gu_dropdownUpdate(e, item, props, state, hide, autoRender);
    },

    getCorrectTransferIconImage(template, provider) {
        const imageMapping = {
            BTI: '/public/html/images/icon/96m.png',
            BTI2: '/public/html/images/icon/96m.png',
            EBET: '/public/html/images/icon/ebet-96m.png',
            FC: '/public/html/images/icon/fachai.png',
            PS: '/public/html/images/icon/playstar.png',
            RG: '/public/html/images/icon/RG.png',
            IBC: '/public/html/images/icon/IBC.png',
            YGG: '/public/html/images/icon/ygg.png',
            SPX: '/public/html/images/icon/SPX.png',
            AP: '/public/html/images/icon/ap.png',
            MTV: '/public/html/images/icon/MTV.png',
            MTL: '/public/html/images/icon/MTL.png',
        };
        if (window.merchantCode === '96b' && imageMapping[provider]) {
            return imageMapping[provider];
        }
        return `/public/html/default_whitelabel/template/images/provider-transfer-icon/${template}/${provider}.png`;
    },

    getMainWallet(vm, isOnLoad, from) {
        vm.setState({
            iconLoading: true,
            restoreOnLoad: true,
        });
        const { user } = vm.props;
        const currentBalance = gu_getNestedValue(vm, 'props.wallet.mainWallet.balance');
        if (user && user.isLogin && !window.isAffiliate) {
            window.SPL_Member.getMainWallet().then((mainWallet) => {
                if (!isOnLoad) {
                    gu_triggerAdElementAction('updateMainWallet', {
                        login: window.lh_ml,
                        currentBalance,
                        latestBalance: gu_getNestedValue(mainWallet, 'data.balance') || 0,
                        viewType: vm.props.screen.viewType,
                        from,
                    });
                }
                vm.setState(
                    {
                        mainWallet: mainWallet.data,
                        iconLoading: false,
                        restoreOnLoad: false,
                    },
                    () => {
                        commonUtil.loadProviders(vm);
                    }
                );
                vm.props.dispatch(walletAction.updateWallet(mainWallet.data));
            });
        }
    },

    loadProviders(vm) {
        vm.setState({ iconLoading: true });
        const { currency } = vm.props.user.account;
        const { t, language, seamless, portal } = vm.props;
        const { sortingProviderTransferPageKey = 'name' } = portal?.settings?.features || {};

        window.SPL_Provider.getAllProviderWalletList(language, false, vm.props).then((data) => {
            let tempProviderList = data.providerList;
            let providerList = [];
            let fromProvider;
            let foundMainWalletIndex = 0;

            let mainWallet = tempProviderList.filter((a) => a.provider === null)[0];
            tempProviderList = tempProviderList.filter((a) => a.provider !== null);
            tempProviderList = tempProviderList.slice(0).sort(function (a, b) {
                return a['provider'] > b['provider'] ? 1 : a['provider'] < b['provider'] ? -1 : 0;
            });

            providerList.push(mainWallet);
            for (let i = 0; i < tempProviderList.length; i++) {
                providerList.push(tempProviderList[i]);
            }

            for (let i = 0; i < providerList.length; i++) {
                let balance = providerList[i].balance;
                providerList[i].display = `${providerList[i].name ? commonUtil.getCorrectProviderName(providerList[i]) : t('settings:settings.mywallet', 'My Wallet')}
                        (${window.SPL_Other.formatAmount(balance) || window.SPL_Other.formatAmount('0')}
                        ${currency}) ${t(providerList[i].serverMaintenenceStr)}`;
                providerList[i].key = providerList[i].provider;

                // default select main wallet
                if (providerList[i].provider === null) {
                    providerList[i].key = 'main';
                    foundMainWalletIndex = i;
                    fromProvider = providerList[i];
                } else {
                    if (providerCore.providers[providerList[i].provider]) {
                        providerList[i].transferSettingIcon = providerCore.providers[providerList[i].provider].transferSettingIcon;
                    } else {
                        // please uncomment this to get to know apa provider missing
                        //console.log(providerList[i].provider);
                    }
                }
            }

            let transferValue = window.SPL_Other.formatAmount(fromProvider.balance) || window.SPL_Other.formatAmount('0');
            transferValue = transferValue.replace(/,/g, '');

            providerList = providerList.slice(0).sort(function (a, b) {
                let valA = a[sortingProviderTransferPageKey];
                let valB = b[sortingProviderTransferPageKey];

                if (valA == null && valB == null) return 0;
                if (valA == null) return 1;
                if (valB == null) return -1;

                return String(valA).localeCompare(String(valB), undefined, {
                    numeric: true,
                    sensitivity: 'base',
                });
            });

            if (seamless?.isSeamless) {
                vm.props.dispatch(seamlessAction.getSeamlessAllProviderWallets(providerList));
            }

            vm.setState({
                providerList: providerList,
                totalvalidturnoveramount: data.totalvalidturnoveramount,
                transferAmount: transferValue,
                foundMainWalletIndex: foundMainWalletIndex,
                iconLoading: false,
                maximumAmount: transferValue,
            });
            vm.props.dispatch(walletAction.updateProviderWallets(providerList));
        });
    },

    getCorrectProviderName(providerObj) {
        switch (providerObj?.provider) {
            case 'PP':
                return 'Pragmatic Play';
            case 'PPL':
                return 'Pragmatic Casino';
            case 'GD':
                return 'GD Gaming';
            case 'BTI':
            case 'BTI2':
                if (window.templateCode && window.templateCode === 'beta') {
                    return 'BK8 Sports';
                }
                return 'BTi-Sports';
            case 'M8':
                return 'M9bet-Sports';
            case 'CMD':
                return 'Cmd-Sports';
            case 'SBO':
            case 'SBO2':
                return 'Sbobet-Sports';
            case 'HC':
                return 'GoldenBay';
            case 'JS':
                if (window.templateCode && window.templateCode === 'beta') {
                    return 'BK8 Euro';
                }
                return 'Jolly Sports';
            case 'AP':
                return 'AdvantPlay';
            case 'WE':
                if (window.templateCode && window.templateCode === 'beta') {
                    return 'BK8 Casino';
                }
                return 'WE Casino';
            case 'R88':
                return 'Rich88';
            case 'AG2':
                return 'PlayAce';
            default:
                return providerObj?.name;
        }
    },

    async providerGrouping(vm, callback) {
        await new Promise((resolve) => {
            let tempSportBooks = vm.state.sportbook;
            let tempESportBooks = vm.state.esport;
            let tempCasino = vm.state.casino;
            let tempSlots = vm.state.slots;
            let tempFishing = vm.state.fishing;
            let tempLottery = vm.state.lottery;
            let tempPoker = vm.state.poker;
            let tempOther = vm.state.others;
            let tempGames = vm.state.games;
            let tempCockFight = vm.state.cockfight;
            let tempLiveGames = vm.state.livegames;

            if (vm.props && vm.props.user && vm.props.user.isLogin && vm.props.user.account && vm.props.user.account.currency) {
                window.SPL_JsonSettings.loadCategoryTypeSettingsJson((data) => {
                    if (data) {
                        let submenu = new Promise(function (resolves) {
                            let returnData = data[vm.props.user.account.currency] ? data[vm.props.user.account.currency] : [];
                            resolves(returnData);
                        });

                        submenu.then(function (resSubmenu) {
                            let tempSubGames = {};
                            for (let i = 0; i < resSubmenu.length; i++) {
                                let menuType = resSubmenu[i].key;
                                let data = resSubmenu[i].list;
                                const subGames = resSubmenu[i].subGames || [];
                                if (data?.length > 0) {
                                    switch (menuType) {
                                        case 'S':
                                            if (vm.props.screen.viewType === 'mobile') {
                                                data = data.filter(function (e) {
                                                    return e !== 'BR';
                                                });
                                            }
                                            tempSportBooks = data;
                                            break;

                                        case 'ES':
                                            tempESportBooks = data;
                                            break;

                                        case 'C':
                                            tempCasino = data;
                                            break;

                                        case 'SL':
                                            tempSlots = data;
                                            break;

                                        case 'F':
                                            tempFishing = data;
                                            break;

                                        case 'L':
                                            tempLottery = data;
                                            break;

                                        case 'P':
                                            tempPoker = data;
                                            break;

                                        case 'RC':
                                            tempOther = data;
                                            break;

                                        case 'G':
                                            tempGames = data;
                                            break;

                                        case 'CF':
                                            tempCockFight = data;
                                            break;

                                        case 'LG':
                                            tempLiveGames = data;
                                            break;

                                        default:
                                            break;
                                    }
                                }

                                if (subGames.length > 0) {
                                    tempSubGames[menuType] = subGames;
                                }
                            }

                            vm.setState(
                                {
                                    sportbook: tempSportBooks,
                                    esport: tempESportBooks,
                                    casino: tempCasino,
                                    slots: tempSlots,
                                    fishing: tempFishing,
                                    lottery: tempLottery,
                                    poker: tempPoker,
                                    others: tempOther,
                                    games: tempGames,
                                    cockfight: tempCockFight,
                                    livegames: tempLiveGames,
                                    subGames: tempSubGames,

                                    providerCategoryType: {
                                        sportbook: tempSportBooks,
                                        esport: tempESportBooks,
                                        casino: tempCasino,
                                        slots: tempSlots,
                                        fishing: tempFishing,
                                        lottery: tempLottery,
                                        poker: tempPoker,
                                        others: tempOther,
                                        games: tempGames,
                                        cockfight: tempCockFight,
                                        livegames: tempLiveGames,
                                    },
                                },
                                () => {
                                    callback && callback();
                                    resolve();
                                }
                            );
                        });
                    }
                });
            } else {
                callback && callback();
                resolve();
            }
        });
    },

    removeDuplicateProvider(array) {
        let uniqueArray = [];
        for (let i = 0; i < array.length; i++) {
            if (array) {
                if (uniqueArray.indexOf(array[i]) === -1) {
                    uniqueArray.push(array[i]);
                }
            }
        }
        return uniqueArray;
    },

    popupUpdate(vm, page, data, category, title, content, isDynamicPage) {
        gu_popupUpdate(vm, page, data, category, title, content, isDynamicPage);
    },

    // type => option/channel/bank/crypto
    // useStandardImgFormat => based on type
    //  option = public/html/{merchantCode}/images/deposit/option/
    //  channel = public/html/{merchantCode}/images/deposit/channel/{currency}/
    //  bank = public/html/{merchantCode}/images/deposit/bank/{currency}/
    //  crypto = public/html/{merchantCode}/images/crypto/
    getDepositImgPath(vm, type) {
        return gu_getDepositImgPath(vm, type);
    },

    getIsFormattedImageSetting(vm) {
        const { depositPagesSettings } = vm.props.portalSettingsReducer.portalSettings.features;
        if (depositPagesSettings) return depositPagesSettings.isFormattedImage;
        return null;
    },

    /**
     * NOTE: json setting some is show some is hide condition...
     * amountNotRequired = hide
     * hasSpecialImportantNotice = show
     *
     * either show / hide, add on settings for future in switch case based on default show / hide
     *
     * controller standardized as show XXX show XXX (no hide)
     */
    getPaymentGatewaySettingBool(paymentGatewaySetting, type, checker) {
        const { amountFieldNotRequired, hasSpecialImportantNotice, hasCardInfo } = PAYMENT_GATEWAY_SETTING;
        let isShow;
        if (!paymentGatewaySetting) {
            switch (type) {
                case amountFieldNotRequired:
                    isShow = true;
                    break;

                case hasSpecialImportantNotice:
                    isShow = false;
                    break;

                case hasCardInfo:
                    isShow = false;
                    break;

                default:
                    break;
            }
        } else {
            if (!paymentGatewaySetting[type]) {
                paymentGatewaySetting[type] = [];
            }

            switch (type) {
                case amountFieldNotRequired:
                    isShow = !paymentGatewaySetting[type].includes(checker ? checker.code : null);
                    break;

                case hasSpecialImportantNotice:
                    isShow = paymentGatewaySetting[type].includes(checker ? checker.code : null);
                    break;

                case hasCardInfo:
                    isShow = paymentGatewaySetting[type].includes(checker ? checker.code : null);
                    break;

                default:
                    break;
            }
        }
        return isShow;
    },

    getDepositAmountFieldNotRequiredConfig(paymentGatewaySetting, checker) {
        const { amountFieldNotRequired } = PAYMENT_GATEWAY_SETTING;
        const showAmountField = commonUtil.getPaymentGatewaySettingBool(paymentGatewaySetting, amountFieldNotRequired, checker);
        return { showAmountField, isFormValid: !showAmountField };
    },
    getBrandLogo(vm) {
        const { language } = vm.props;
        window.SPL_Content.getBrandLogo(language.countryLanguageKey).then((res) => {
            vm.setState({ brandLogoObj: res });
        });
    },

    // Params
    // div (Required) -> target element
    // oriStyles (Required) -> style to apply
    // newStyles (Optional) -> style to overwrite jsonStyle by key
    // customStyles -> if got customStyles (assume ori/new styles is shared style)
    handleHoverOrUnhoverStyleFromJson(params) {
        const { div, oriStyles, newStyles, isHover, customStyles } = params;

        if (div) {
            let target = div;
            let targetClassName = target.className;
            targetClassName = target.tagName === 'svg' ? target.className.baseVal : targetClassName;

            if (isHover) {
                if (targetClassName && targetClassName.includes('active')) {
                    return;
                }
                let hoveredStyles = commonUtil.jsonConcat(oriStyles, newStyles);
                hoveredStyles = customStyles ? commonUtil.jsonConcat(hoveredStyles, customStyles) : hoveredStyles;

                for (let key in hoveredStyles) {
                    target.style[key] = hoveredStyles[key];
                }
            } else {
                if (targetClassName && targetClassName.includes('active')) {
                    return;
                }
                if (newStyles) {
                    for (let i = 0; i < Object.keys(newStyles).length; i++) {
                        let newKey = Object.keys(newStyles)[i];
                        let oriKey = Object.keys(oriStyles).find((e) => e === newKey);
                        let oriValue = oriKey ? oriStyles[oriKey] : null;

                        if (!oriKey) {
                            target.style[newKey] = null;
                        } else {
                            target.style[oriKey] = oriValue;
                        }
                    }
                }
            }
        }
    },

    scrollElementIntoView(vm, element, behavior) {
        const { screen } = vm.props;
        let scrollTop = window.pageYOffset || element.scrollTop;

        // BA requirements: for mobile push the tab to be the 3rd place when open it
        const additionalOffSet = screen.isMobile ? 112 : 0;
        const finalOffset = element.getBoundingClientRect().top + scrollTop - additionalOffSet;

        window.parent.scrollTo({
            top: finalOffset,
            behavior: behavior,
        });
    },

    checkHideRegisterFieldFlag(flag, currency) {
        if (flag && flag.length > 0) {
            if (flag.includes(currency)) {
                flag = flag.includes(currency);
            } else {
                flag = false;
            }
        }

        return flag;
    },

    getDoubleDigit(param) {
        param = param.toString();
        if (param.length < 2) {
            param = '0' + param;
        }
        return param;
    },

    handleExternalLoginRegister(vm, smProvider, action) {
        if (smProvider) {
            switch (smProvider) {
                case 'line':
                    memberService.getExternalLoginRegister(vm, action, smProvider && smProvider.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    },

    togglePopup(vm, component, customPopUpContent) {
        return gu_togglePopup(vm, component, customPopUpContent); // moved to general-util.js
    },

    addDefaultSrc(e, defaultPath, currentProvider, vm) {
        let defaultImg = defaultPath;
        let http = new XMLHttpRequest();

        if (vm && vm.props) {
            const { portalSettings } = vm.props.portalSettingsReducer;

            if (currentProvider && portalSettings && portalSettings.images_template && portalSettings.images_template.provider_banner) {
                const { provider, game } = currentProvider;
                let imgTemplate = portalSettings.images_template.provider_banner;

                defaultImg = `/public/html/games/images/${imgTemplate}/${provider}/${game}.jpg`;
            }
        }

        http.open('HEAD', defaultImg, false);
        http.send();

        if (http.status !== 404) {
            e.target.src = defaultImg;
        }
    },

    redirectLinkedMerchant(vm, menuObj) {
        const { user, portalSettingsReducer, language } = vm.props;
        const { linkedMerchantDomain, redirectLinkedMerchantProvider } = portalSettingsReducer.portalSettings;

        if (
            user &&
            user.isLogin &&
            redirectLinkedMerchantProvider &&
            redirectLinkedMerchantProvider[user.account.currency] &&
            redirectLinkedMerchantProvider[user.account.currency].some((e) => e === menuObj.provider)
        ) {
            if (linkedMerchantDomain) {
                const domain = window.location.hostname;
                const token = window.SPL_Cookie.getCookie('t') || '';
                const affId = window.SPL_Cookie.getCookie('AffCode') || '';
                const refId = window.SPL_Cookie.getCookie('RefCode') || '';

                const linkedMerchantUrl = linkedMerchantDomain[domain] || linkedMerchantDomain['default'];
                const url = `${linkedMerchantUrl}/linked-landing-page?merchantCode=${window.merchantCode}&token=${token}&affId=${affId !== '000' && affId}&refId=${refId}`;

                window.open(url);
            }
        } else if (
            redirectLinkedMerchantProvider &&
            redirectLinkedMerchantProvider[language.currencyLang] &&
            redirectLinkedMerchantProvider[language.currencyLang].some((e) => e === menuObj.provider)
        ) {
            vm.props.dispatch(portalAction.showLoginAlert(true));
        }
    },

    subscribeEmbedVideoEvent(iframe) {
        const player = getOrCreateEmbedPlayer(iframe);
        if (!player) return;

        // clear any existing handlers before re-subscribing to avoid duplicates
        player.off('ready');
        player.off('play');
        player.off('pause');
        player.off('mute');

        player.on('ready', () => {
            player.on('play');
            player.on('pause');
            player.on('mute');
        });
    },

    unsubscribeEmbedVideoEvent(iframe) {
        const player = EMBED_PLAYER_MAP.get(iframe);
        if (!player) return;

        player.off('ready');
        player.off('play');
        player.off('pause');
        player.off('mute');

        EMBED_PLAYER_MAP.delete(iframe);
        // after this player instance has no reference to itself, then it can be garbage collected
    },

    pauseEmbedVideo(iframe) {
        const player = EMBED_PLAYER_MAP.get(iframe) || getOrCreateEmbedPlayer(iframe);
        if (!player) return;
        try {
            player.pause();
        } catch (e) {
            // ignore if underlying player implementation doesn't support pause directly
        }
    },

    getDepositMinMax(vm, transactionOption, currency, bank, coin = null, bankType = null, selectedChainId, callback) {
        let param = {};
        if (transactionOption === 'CT') {
            param = {
                transactionOption: transactionOption,
                currency: currency,
                bankCode: bank,
                cryptoCoin: coin,
                merchantCode: window.merchantCode,
                bankType: bankType,
            };
        } else {
            if (isNaN(bank)) {
                param = {
                    transactionOption: transactionOption,
                    currency: currency,
                    bankCode: bank ? bank : vm.state.bankCode,
                    merchantCode: window.merchantCode,
                };
            } else {
                param = {
                    transactionOption: transactionOption,
                    currency: currency,
                    id: bank,
                    merchantCode: window.merchantCode,
                };
            }
            if (transactionOption === 'E') {
                param['bankCode'] = bank;
            }
        }

        if (!window.isAffiliate) {
            window.SPL_Transaction.getDepositMinMax(param).then((data) => {
                if (data) {
                    const depositMinMaxLimit = normalizeDepositLimit(data, transactionOption, vm.props.t);
                    vm.setState({ depositMinMaxLimit: depositMinMaxLimit });
                }
                vm.setState({ isLoading: false });
                callback && callback();
            });
        } else {
            const affiliateParam = {
                ...param,
                id: selectedChainId,
            };

            window.SPL_Transaction.getDepositMinMax(affiliateParam).then((data) => {
                if (data) {
                    vm.setState({ depositMinMaxLimit: data });
                }
                callback && callback();
            });
        }
    },

    objectToGetParams(object) {
        var params = Object.entries(object)
            .filter(function (_a) {
                var value = _a[1];
                return value !== undefined && value !== null;
            })
            .map(function (_a) {
                var key = _a[0],
                    value = _a[1];
                return encodeURIComponent(key) + '=' + encodeURIComponent(String(value));
            });
        return params.length > 0 ? '?' + params.join('&') : '';
    },

    startDateMaxDateCheck(endDate) {
        if (endDate === null || endDate === '') {
            return new Date();
        } else {
            return endDate;
        }
    },

    hideShowDecimalCheck(vm, number, t, useFormatAmountNoDecimal) {
        const { portalSettings } = vm.props.portalSettingsReducer;

        if (number) {
            if (portalSettings && portalSettings.features && portalSettings.features.hideDepositDecimal) {
                number = window.SPL_Other.formatAmountNoDecimal(number, t);
            } else {
                if (useFormatAmountNoDecimal) {
                    number = window.SPL_Other.formatAmountNoDecimal(number, t);
                } else {
                    number = window.SPL_Other.formatAmount(number, t);
                }
            }
        }

        return number;
    },

    reduxDateUpdate(date, type, props = false) {
        if (type === 'message') {
            props.dispatch(dateAction.updateMessageDatePersist(date));
        }
    },

    initComm100(props, isLogin, account) {
        gu_initComm100(props, isLogin, account);
    },

    onClickMenuTabFunction(vm, tabSelected) {
        const { portalSettingsReducer } = vm.props;

        if (
            gu_getNestedValue(vm.props, 'portalSettingsReducer.menuTabSelected') !== vm.state.selectedMenu &&
            gu_getNestedValue(portalSettingsReducer, 'portalSettings.features.navbarSettings.navMenu.customTabsColor')
        ) {
            vm.props.dispatch(portalAction.setMenuTabSelected(tabSelected));
        }
    },

    onRenderLottieGetJsonContent(path, cacheName) {
        if (!path) return null;

        return new Promise((resolve, reject) => {
            window.SPL_JsonSettings.getHTMLbyCache(
                path,
                cacheName,
                (data) => {
                    resolve(data?.data || data || null);
                },
                () => {
                    reject(null);
                }
            );
        });
    },

    sortSuperSportsProvider(providers) {
        const spsIndex = providers.findIndex((provider) => provider?.provider === 'SPS');
        if (spsIndex === -1) {
            return providers;
        }
        const newProviders = [...providers];
        const [spsProvider] = newProviders.splice(spsIndex, 1);
        newProviders.unshift(spsProvider);

        return newProviders;
    },

    getMinDepositOptionButton(params) {
        const { portalSettings, depositOptions, depositMinMaxLimit } = params;
        const minDepositLimit = window.SPL_Other.formatAmount(depositMinMaxLimit?.min);

        let options = [];

        if (Array.isArray(depositOptions)) {
            options = depositOptions;
        } else if (typeof depositOptions === 'string') {
            options = depositOptions.split(',');
        }

        const validDepositOptionButton = options.map((amount) => parseFloat(amount)).filter((amount) => !isNaN(amount) && amount >= parseFloat(minDepositLimit));

        const enableMinDepositOptionButton = portalSettings?.features?.enableMinDepositOptionButton ?? true;

        const filteredAmounts = enableMinDepositOptionButton ? validDepositOptionButton : depositOptions;

        return filteredAmounts;
    },

    formatCurrentLanguage(lng) {
        return gu_formatCurrentLanguage(lng);
    },

    convertImgSrcToWebP(src, useWebP = false) {
        if (!src) return null;
        try {
            return useWebP && src.match(/\.(png|jpe?g)$/i) ? src.replace(/\.(png|jpe?g)$/, '.webp') : src;
        } catch (error) {
            return null;
        }
    },

    getLocalizedValue(vm, featureObject) {
        if (typeof featureObject === 'boolean') {
            return featureObject;
        }

        if (typeof featureObject === 'object') {
            return gu_getContentByCurrencyLanguage(vm, featureObject);
        }

        return false;
    },
};

export default commonUtil;

export function normalizeDepositLimit(limitData, optionCode, t) {
    if (optionCode !== 'CT' || !limitData || typeof limitData !== 'object') return limitData;
    const result = { ...limitData };
    const rawMax = result.max;
    const isUnlimited = rawMax == null || Number(rawMax) === 0;

    if (isUnlimited) {
        result.max = t('transaction:transaction.deposit.onlinetransfer.unlimited', 'Unlimited');
    }
    return result;
}
